// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:47:08.932Z
// Property: Austin Park (ID: 6767906449167172)
// Collections: 16 amenities, 2 floorplans (live), 27 photos, 74 POIs, 4 reviews, 5 office hours, 1 special offers (live), 12 fees (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167172",
  "property_external_id": "785471",
  "property_zillow_url": "https://www.zillow.com/apartments/colorado-springs-co/austin-park/5XhvVN/",
  "property_apartments_url": "https://www.apartments.com/austin-park-colorado-springs-co/c62hl6d/",
  "property_google_business_url": "https://www.google.com/maps/place/Austin+Park/data=!4m2!3m1!1s0x0:0x98354a4984731770?sa=X&ved=2ahUKEwjqnujl54OTAxUGjokEHTEhFxsQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47754542623",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "austin-park",
  "property_name": "Austin Park",
  "property_website_url": "https://www.austinparkapartmenthomes.com",
  "property_domain": "https://www.austinparkapartmenthomes.com",
  "property_address": "3940 Harmony Dr",
  "property_full_address": "3940 Harmony Dr, Colorado Springs, CO 80917",
  "property_address_1": "3940 Harmony Dr",
  "property_address_2": null,
  "property_address_city": "Colorado Springs",
  "property_address_state": "CO",
  "property_address_zip_full": "80917",
  "property_address_zip": "80917",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Village Seven",
  "property_address_latitude": "38.8891406",
  "property_address_longitude": "-104.7540309",
  "property_email": "austinpark@weidner.com",
  "property_phone": "7198266344",
  "property_call_tracking_phone": "719-426-3522",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Austin Park, where comfort meets convenience in the heart of Colorado Springs. Enjoy spacious one and two-bedroom apartments with modern amenities, from energy-efficient appliances to serene mountain views. Unwind by the pool, explore the picnic area, or relax in our landscaped courtyard. Your new home awaits!",
  "property_long_description": "Welcome to Austin Park, the perfect blend of comfort and convenience in beautiful Colorado Springs, CO! Our vibrant apartment community offers a variety of thoughtfully designed floor plans, including spacious one-bedroom and two-bedroom options to suit your lifestyle. Nestled among breathtaking mountain views, Austin Park is your ideal retreat.\n\nExperience a host of modern amenities that enhance your living experience. Enjoy 24-hour access to our well-maintained facilities, with a dedicated property manager and maintenance team onsite to ensure peace of mind. Take advantage of our laundry facilities, allocated storage space, and high-speed internet access for effortless living. Whether you're lounging by the pool, hosting a barbecue in the picnic area, or enjoying family fun at the playground, our community caters to every need.\n\nStep into your new home, where energy-efficient appliances meet contemporary designs. Each apartment features central AC, walk-in closets, and sleek kitchen remodels with a full array of appliances, including a refrigerator, oven, and more. Enjoy the luxury of instant hot water, plush carpet, and stylish vinyl flooring, all within a smoke-free environment.\n\nEmbrace the outdoors with beautifully landscaped gardens, expansive courtyards, and a sundeck perfect for soaking up the Colorado sun. Plus, with convenient bike storage and scenic views, adventure is just a ride away!\n\nFind your new home today at Austin Park—where comfort meets community! Browse our availability or schedule a tour to experience all that our charming apartment community has to offer. Your ideal lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-dd96-76ad-86e0-d40ad9ac5a53.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with a large flat-screen TV, black leather sofas, and a coffee table.",
    "public_id": "019d021b-dd96-76ad-86e0-d40ad9ac5a53",
    "storage_key": "property/6767906449167172/019d021b-dd96-76ad-86e0-d40ad9ac5a53.webp",
    "width": 800,
    "height": 528
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "90",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": "66",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.33333333333333",
  "property_admin_fee": "200",
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security deposit: $500 (refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "60",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://austinparkapartmenthomes.securecafe.com/onlineleasing/austin-park/floorplans.aspx",
  "property_resident_portal_url": "https://austinparkapartmenthomes.securecafenet.com/residentservices/austin-park/userlogin",
  "property_apply_now_url": "https://austinparkapartmenthomes.securecafe.com/onlineleasing/austin-park/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d5-36cb-7165-941c-25b8279f792b.webp",
  "property_primary_logo_media": {
    "alt_text": "Austin Park Apartment Homes logo.",
    "public_id": "01a140d5-36cb-7165-941c-25b8279f792b",
    "storage_key": "property/6767906449167172/01a140d5-36cb-7165-941c-25b8279f792b.webp",
    "width": 299,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d5-6947-75c1-b45d-5b734715d32e.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a140d5-6947-75c1-b45d-5b734715d32e",
    "storage_key": "property/6767906449167172/01a140d5-6947-75c1-b45d-5b734715d32e.webp",
    "width": 299,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d5-5fe1-72ce-99e7-6801ed43cb4d.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a140d5-5fe1-72ce-99e7-6801ed43cb4d",
    "storage_key": "property/6767906449167172/01a140d5-5fe1-72ce-99e7-6801ed43cb4d.webp",
    "width": 299,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#E5C64A",
  "property_secondary_color": "#F5EDD5",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#221E1F",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 720",
  "property_sqft_min": "460",
  "property_sqft_max": "720",
  "property_price_range": "847 - 1720",
  "property_price_min": "945",
  "property_price_max": "1715",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/AustinParkApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/austinparkapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJeUQW6UxPE4cRcBdzhElKNZg",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Austin Park Apartments",
  "property_home_romance_title": "Welcome to Austin Park",
  "property_home_amenities_blurb": "Welcome to Austin Park, where modern living meets breathtaking mountain views in Colorado Springs. Choose from spacious one and two-bedroom floor plans, complemented by exceptional amenities like a refreshing pool, picnic area, and on-site maintenance. Embrace comfort and convenience in your new home today!",
  "property_home_floorplans_blurb": "Welcome to Austin Park in the heart of Colorado Springs, where modern living meets natural beauty. Our thoughtfully designed floor plans cater to every lifestyle, offering spacious layouts and stunning views. Browse our available apartment homes today and find the perfect space that reflects your unique vision of home.",
  "property_home_gallery_blurb": "At Austin Park in Colorado Springs, comfort meets modern living. Choose from our spacious one and two-bedroom floor plans, featuring energy-efficient appliances and stunning mountain views. Enjoy amenities like a refreshing pool, serene picnic area, and on-site management. Picture yourself living here, where convenience and relaxation blend seamlessly.",
  "property_home_neighborhood_blurb": "<p>Austin Park puts you close to everyday needs and local favorites - shop at Walmart, catch a class at the University of Colorado Colorado Springs, or wander the trails at Palmer Park. Beyond walkable essentials, the area's lively local eateries and open green spaces mean you'll always have something to enjoy just steps from home.</p>",
  "property_home_reviews_blurb": "At Austin Park in beautiful Colorado Springs, residents rave about the vibrant community atmosphere, stating, \"Living here feels like being part of a family.\" Experience modern amenities, scenic views, and a welcoming environment. Curious about life at Austin Park? Check out the heartfelt testimonials from our happy residents!",
  "property_neighborhood_blurb": "<p>Life at Austin Park Apartments puts you in the heart of Village Seven in Colorado Springs, CO. Walk to Walmart for daily errands or grab your morning coffee. Enjoy being near the University of Colorado - Colorado Springs campus for school or work. Spend weekends hiking at Palmer Park or exploring local shopping, dining, and recreation options right out your door. Whether you work nearby or commute, home feels connected and easy to get to.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Austin Park Apartments in Colorado Springs, CO, your lifestyle blends in-home comfort with community conveniences. Retreat inside to enjoy energy-efficient appliances, central A/C and heating, and a linen closet, with select homes framed by a stunning Colorado mountain backdrop. Head outside for a refreshing dip in the pool, plus grill and picnic spaces, all in a pet-friendly atmosphere made for connection.</p>",
  "property_applynow_blurb": "At Austin Park in Colorado Springs, your ideal living space awaits—choose from spacious one or two-bedroom floor plans with stunning mountain views. Enjoy modern amenities like 24-hour access, resort-style pool, and tranquil picnic areas. Elevate your lifestyle with energy-efficient appliances and community comforts. Lease online today, and claim your new home!",
  "property_contactus_blurb": "<p>Have questions or want to learn more about Austin Park? Reach out to our leasing team in Colorado Springs, CO, for additional info or to schedule a visit. We're here to help you find the right apartment and answer your questions about our community or the neighborhood.</p>",
  "property_faqs_blurb": "At Austin Park in Colorado Springs, CO, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Have questions? Our FAQs page holds the key to understanding our vibrant community's offerings. Dive into details and find the answers you seek to elevate your living experience!",
  "property_floorplans_blurb": "<p>Explore bright, spacious one- and two-bedroom apartments for rent in Colorado Springs, CO, at Austin Park. Each home features central A/C, energy-efficient appliances, and a thoughtful layout for easy living - from cozy evenings to remote work or unwinding with your pet. Enjoy smart storage and room to personalize, all wrapped in transparent, all-in pricing so you can plan with peace of mind.</p>",
  "property_gallery_blurb": "<p>Scroll through vibrant images of Austin Park's Colorado Springs apartments and community spaces. Peek inside bright kitchens, see inviting living rooms ready for your personal touches, and imagine relaxing by the sparkling outdoor pool or gathering by the picnic grills. Get a sense of the calm, comfy lifestyle waiting for you here, whether inside your airy apartment or outdoors, surrounded by mountain views.</p>",
  "property_interactivemap_blurb": "At Austin Park in scenic Colorado Springs, our inviting one- and two-bedroom apartments combine modern living with breathtaking mountain views. Enjoy 24-hour access and premium amenities like a refreshing pool, BBQ area, and dedicated maintenance. Use our interactive community map to find your perfect home and embrace a vibrant lifestyle today!",
  "property_pets_blurb": "At Austin Park in beautiful Colorado Springs, we know that pets are family! Enjoy life in our vibrant community with your furry companions—cats and dogs up to 60 lbs are welcome. With scenic trails nearby, your pets will love every moment exploring their new home.",
  "property_referafriend_blurb": "At Austin Park in Colorado Springs, CO, we celebrate community and connection. With thoughtfully designed one and two-bedroom apartments, there’s a perfect home for everyone. Great friends make great neighbors—refer a friend today and let them experience the vibrant lifestyle that awaits at Austin Park!",
  "property_residentaccess_blurb": "Welcome to Austin Park in beautiful Colorado Springs, CO, where your ideal living space awaits. Choose from stylish one and two-bedroom floor plans tailored for comfort. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected to your vibrant community—all at your fingertips!",
  "property_reviews_blurb": "At Austin Park in Colorado Springs, residents rave, \"This community truly feels like home!\" Nestled amidst stunning landscapes, our welcoming atmosphere and dedicated staff make every day special. Dive into our reviews and see what our residents have to say about living at our vibrant community!",
  "property_created_at": "1771535736177",
  "property_scheduletour_blurb": "<p>Ready to see more? Schedule your preferred tour at Austin Park Apartments in Colorado Springs, CO. Choose an in-person or live virtual walkthrough with our knowledgeable leasing team, or explore online on your own time. Preview everything from our one- and two-bedroom layouts to community perks like the sunny pool and grill areas - all at your pace. Touring restrictions may apply.</p>",
  "property_thankyou_blurb": "Thank you for reaching out to Austin Park! Nestled in the heart of Colorado Springs, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Stay tuned; a friendly member of our team will connect with you soon to help you find your perfect home.",
  "property_virtualtours_blurb": "<p>Take a virtual tour and get a feel for Austin Park Apartments in Colorado Springs, CO, before you arrive. Walk through floor plans, see how open kitchens connect to living areas, and imagine a simpler daily routine with practical storage. Whether you're relocating or planning, an online tour shows the bright, welcoming vibe and lifestyle awaiting you, wherever you are.</p>",
  "property_copyright": "2026 All Rights Reserved. Austin Park",
  "property_seo_title_home": "Scenic Views | Austin Park | Colorado Springs, CO",
  "property_seo_description_home": "Live relaxed with mountain views, flexible leases, and all-in pricing at Austin Park Apartments in Colorado Springs, CO.",
  "property_seo_title_floorplans": "Floor Plans | Austin Park | Colorado Springs, CO",
  "property_seo_description_floorplans": "Choose your ideal one- or two-bedroom floor plan at Austin Park, Colorado Springs, CO. All-in pricing, modern touches, mountain views, and comfortable layouts.",
  "property_seo_title_amenities": "Amenities | Austin Park | Colorado Springs, CO",
  "property_seo_description_amenities": "Enjoy a pool, grills, laundry, and mountain-view apartments at Austin Park, Colorado Springs, CO.",
  "property_seo_title_gallery": "Photo Gallery | Austin Park | Colorado Springs, CO",
  "property_seo_description_gallery": "Browse photos of Austin Park's apartments, pool, and community spaces in Colorado Springs, CO. Picture your life here.",
  "property_seo_title_virtualtours": "Virtual Tour | Austin Park | Colorado Springs, CO",
  "property_seo_description_virtualtours": "Explore Austin Park Apartments virtually in Colorado Springs, CO. Tour layouts, imagine life here - all from wherever you are.",
  "property_seo_title_interactivemap": "Interactive Map | Austin Park Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Austin Park, Colorado Springs! Explore one and two-bedroom apartments with mountain views and great amenities!",
  "property_seo_title_neighborhood": "Village Seven | Austin Park | Colorado Springs, CO",
  "property_seo_description_neighborhood": "Discover the Village Seven neighborhood around Austin Park Apartments in Colorado Springs, CO. Close to Walmart, UCCS, and Palmer Park.",
  "property_seo_title_contact": "Contact Austin Park Apartments | Colorado Springs, CO",
  "property_seo_description_contact": "Connect with Austin Park Apartments in Colorado Springs, CO. Reach out to our friendly leasing team for details or to schedule a tour.",
  "property_seo_title_faqs": "FAQs | Apartments in Colorado Springs, CO",
  "property_seo_description_faqs": "Find answers to your questions about Austin Park in Colorado Springs. From floor plans to amenities, discover what makes our community uniquely inviting!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Colorado Springs, CO",
  "property_seo_description_reviews": "See what residents love about Austin Park in Colorado Springs! Luxurious amenities, beautiful mountain views, and a vibrant community await. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Colorado Springs, CO",
  "property_seo_description_applynow": "Find your ideal home at Austin Park in Colorado Springs! Enjoy amenities like a pool, playground, and breathtaking mountain views. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Austin Park",
  "property_seo_description_residentaccess": "Access your Austin Park resident portal to effortlessly pay rent, schedule maintenance, and connect with your community in beautiful Colorado Springs.",
  "property_seo_title_referafriend": "Refer A Friend | Austin Park",
  "property_seo_description_referafriend": "Refer a friend to Austin Park in Colorado Springs and create a vibrant community together! Great friends make great neighbors—let’s grow our family today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Austin Park | Colorado Springs, CO",
  "property_seo_description_scheduletour": "Book a tour of Austin Park Apartments in Colorado Springs, CO. Choose in-person, virtual, or guided options.",
  "property_seo_title_privacy": "Privacy Policy | Austin Park",
  "property_seo_description_privacy": "Safeguarding your data is our priority at Austin Park. Dive into our privacy policy to see how we protect your information. Your trust matters!",
  "property_seo_title_accessibility": "Website Accessibility | Austin Park",
  "property_seo_description_accessibility": "At Austin Park in Colorado Springs, we promote digital inclusion for all residents. Join our thriving community today!",
  "property_seo_title_sitemap": "Sitemap | Austin Park",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Austin Park! Check out our sitemap for a comprehensive view of all our unique offerings in beautiful Colorado Springs.",
  "property_seo_title_thankyou": "Thank You | Austin Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Austin Park in Colorado Springs! Your inquiry is important to us—watch for our team’s prompt response for your future home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Colorado Springs, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793797323919",
  "amenities": [
    {
      "id": "ec_26963a4c9ba6b7a68fae9fc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111640",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a171a1-8bcd-7748-898a-809899b7619d.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a171a1-8bcd-7748-898a-809899b7619d",
        "storage_key": "property/6767906449167172/01a171a1-8bcd-7748-898a-809899b7619d.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Austin Park Swimming Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8f51969c5f9518d11b99b74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111634",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a171a1-8cd6-75ff-964c-0d1fdb4667f5.webp",
      "amenity_image_media": {
        "alt_text": "Picnic tables, grills, and a playground in the community courtyard.",
        "public_id": "01a171a1-8cd6-75ff-964c-0d1fdb4667f5",
        "storage_key": "property/6767906449167172/01a171a1-8cd6-75ff-964c-0d1fdb4667f5.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Austin Park Playground",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02b37b3faaee432f1671b79b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111605",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_001264c76b6348184bf4c122",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111598",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b08c8639cb01130b58d65d86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111599",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77bab85039c51f6f16631e4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111601",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7703d69f9f03f170889055a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111629",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_096da1a5a78dcbf70af9894c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111633",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_000c586d5478cc078249b7ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111637",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed1520d121e0c4647577ad35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111662",
      "title": "Mountain Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a171a1-8b81-73a9-ac2d-cee5e1dc5113.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of multifamily property buildings with green lawn and mountains in the background.",
        "public_id": "01a171a1-8b81-73a9-ac2d-cee5e1dc5113",
        "storage_key": "property/6767906449167172/01a171a1-8b81-73a9-ac2d-cee5e1dc5113.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Austin Park Mountain View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_292b97afcbaea0c56147a1b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111647",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92627f2c9ee8c496cbc886fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111657",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7381ad0beb3b54e030391dd5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111606",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-4d56-7058-b5f6-68a38c67394a.webp",
      "amenity_image_media": {
        "alt_text": "Kitchenette with coffee station and stove.",
        "public_id": "019d021c-4d56-7058-b5f6-68a38c67394a",
        "storage_key": "property/6767906449167172/019d021c-4d56-7058-b5f6-68a38c67394a.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Austin Park Common Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7390c42c3d6c3c284a1df856",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111639",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23e221369d2021df0463489b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "86111665",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af71955f1b0c4841ac50cc77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "124799831",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d8ae439ba87b7b261d616d70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-dd96-76ad-86e0-d40ad9ac5a53.webp",
      "image_media": {
        "alt_text": "Modern living room with a large flat-screen TV, black leather sofas, and a coffee table.",
        "public_id": "019d021b-dd96-76ad-86e0-d40ad9ac5a53",
        "storage_key": "property/6767906449167172/019d021b-dd96-76ad-86e0-d40ad9ac5a53.webp",
        "width": 800,
        "height": 528
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish living room, featuring plush seating and entertainment center, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "A cozy living room here at Austin Park featuring a modern seating arrangement with dark leather sofas, a TV on a media console, a central coffee table, and a soft area rug, complemented by neutral walls, a large window with vertical blinds, and warm lighting that creates a comfortable and inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(1).JPG"
    },
    {
      "id": "ec_e00b8c2dde1d67732d9dc67f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-dd26-746b-8ed1-bb12b65ea5b6.webp",
      "image_media": {
        "alt_text": "Living room with dark leather sofas, a coffee table, a TV, and a large window.",
        "public_id": "019d021b-dd26-746b-8ed1-bb12b65ea5b6",
        "storage_key": "property/6767906449167172/019d021b-dd26-746b-8ed1-bb12b65ea5b6.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Step into a welcoming living room featuring comfortable seating, a modern entertainment center, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "A bright living room here at Austin Park showcasing a spacious layout with modern dark leather sofas, a coordinating accent chair, a central coffee table set on a plush area rug, a TV with media console, soft ambient lighting, and a large window with vertical blinds that fills the space with natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(2).jpg"
    },
    {
      "id": "ec_c03986cd5005aaa2d6f87a33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-dd24-700d-9ab0-e36a68172d12.webp",
      "image_media": {
        "alt_text": "Living room with brown leather sofa, armchair, coffee table, and TV.",
        "public_id": "019d021b-dd24-700d-9ab0-e36a68172d12",
        "storage_key": "property/6767906449167172/019d021b-dd24-700d-9ab0-e36a68172d12.webp",
        "width": 708,
        "height": 473
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable brown leather sofa, armchair, and coffee table. Entertainment center with a TV and decorative plants add to the warm ambiance.",
      "link": "false",
      "alt_text": "A cozy living room here at Austin Park featuring warm neutral carpeting, a brown leather sofa and matching armchair, a round glass-top coffee table with greenery, a side table with a table lamp, framed wall art, lush indoor plants, a TV on a media stand, and a wide window with blinds providing soft natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(3).jpg"
    },
    {
      "id": "ec_30cf04ec5b981c539577cc8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-e9ad-706e-bda1-9c148b0ca862.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and artwork.",
        "public_id": "019d021b-e9ad-706e-bda1-9c148b0ca862",
        "storage_key": "property/6767906449167172/019d021b-e9ad-706e-bda1-9c148b0ca862.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a modern coffee table, and tasteful wall art, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A bright living room here at Austin Park featuring a light gray sectional sofa with matching throw pillows, a wooden coffee table with decorative accents, a soft neutral area rug, abstract wall art above the sofa, a potted plant for greenery, vertical window blinds, and natural light filling the open, inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(4).jpg"
    },
    {
      "id": "ec_680e5cfefa8793b43d4e8695",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-e9ad-706e-bda1-99c2c112d2a2.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area of an apartment",
        "public_id": "019d021b-e9ad-706e-bda1-99c2c112d2a2",
        "storage_key": "property/6767906449167172/019d021b-e9ad-706e-bda1-99c2c112d2a2.webp",
        "width": 800,
        "height": 534
      },
      "title": "Apartment",
      "description": "View of a living area and open kitchen with appliances, furniture, and decor.",
      "link": "false",
      "alt_text": "A bright open-concept living room here at Austin Park showcasing a compact kitchen with light cabinetry, black appliances, and wood-style flooring that opens into a cozy living area with modern seating, a media console with TV, a coffee table, soft carpeting, vertical window blinds, and natural light creating a comfortable, welcoming layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(5).jpg"
    },
    {
      "id": "ec_379ebe416bbde6a82d4328ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16caf-f439-73d8-bb80-4e197d9ee42e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with black appliances.",
        "public_id": "01a16caf-f439-73d8-bb80-4e197d9ee42e",
        "storage_key": "property/6767906449167172/01a16caf-f439-73d8-bb80-4e197d9ee42e.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "A spacious living area flows seamlessly into a functional kitchen, featuring black appliances and ample cabinet space, perfect for everyday living.",
      "link": "false",
      "alt_text": "A bright, unfurnished living area here at Austin Park showcasing soft beige carpet flooring, clean white walls, and an open layout that flows into a compact kitchen with warm wood cabinetry, black appliances, vinyl flooring, and overhead lighting, creating a flexible space ideal for both living and dining furniture arrangements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(32).jpg"
    },
    {
      "id": "ec_665713099a42f865b22bebaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-01f0-762b-a74e-5e5671656f3c.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area with a large window.",
        "public_id": "019d021c-01f0-762b-a74e-5e5671656f3c",
        "storage_key": "property/6767906449167172/019d021c-01f0-762b-a74e-5e5671656f3c.webp",
        "width": 800,
        "height": 550
      },
      "title": "Apartment",
      "description": "Enjoy the open concept living space, featuring a functional kitchen with ample cabinet storage and a spacious living area perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "A bright, unfurnished living room here at Austin Park featuring soft neutral carpeting, white walls, and a wide window with vertical blinds that brings in natural light, connected to a compact kitchen with wood-look flooring, light cabinetry, laminate countertops, a black dishwasher, and a stainless sink for a functional open layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(12).jpg"
    },
    {
      "id": "ec_0147e0dbde626dca8f90ad6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021b-f54a-771e-b6ec-2f355386b99e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, and a large window.",
        "public_id": "019d021b-f54a-771e-b6ec-2f355386b99e",
        "storage_key": "property/6767906449167172/019d021b-f54a-771e-b6ec-2f355386b99e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom featuring a comfortable queen-sized bed, elegant nightstands, and a large window offering natural light.",
      "link": "false",
      "alt_text": "A bright, airy bedroom here at Austin Park featuring a softly upholstered bed with crisp white bedding, neutral accent pillows, matching bedside tables with modern lamps, abstract wall art above the headboard, plush carpet flooring, and a large window with vertical blinds that fills the space with natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(8).jpg"
    },
    {
      "id": "ec_453bfb99e84e550ce89e47ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16caf-f258-74bc-8102-47672cf5ee7d.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and large window with vertical blinds.",
        "public_id": "01a16caf-f258-74bc-8102-47672cf5ee7d",
        "storage_key": "property/6767906449167172/01a16caf-f258-74bc-8102-47672cf5ee7d.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "This is an empty bedroom with carpet and a large window that lets in natural light. It's ready for you to make it your own.",
      "link": "false",
      "alt_text": "A bright, unfurnished bedroom here at Austin Park featuring neutral carpet flooring, soft beige walls, a large window with vertical blinds that allow natural light to fill the space, clean baseboards, and an open layout that offers flexibility for bedroom furniture and décor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(35).jpg"
    },
    {
      "id": "ec_a96be011c4c946c6d1953e19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16caf-f43b-710b-bf02-0a5799c57af5.webp",
      "image_media": {
        "alt_text": "Empty bedroom with plush carpet and a large window",
        "public_id": "01a16caf-f43b-710b-bf02-0a5799c57af5",
        "storage_key": "property/6767906449167172/01a16caf-f43b-710b-bf02-0a5799c57af5.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Spacious bedroom with soft carpeting and abundant natural light filtering through a large window, perfect for creating your personal sanctuary.",
      "link": "false",
      "alt_text": "A bright, spacious bedroom here at Austin Park featuring soft neutral walls, plush carpet flooring, and a large window that brings in natural light and offers a pleasant outdoor view, creating a versatile space ideal for a comfortable bedroom setup or home office.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(37).jpg"
    },
    {
      "id": "ec_b8ea1df600299d13191a2635",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-06d7-7149-8087-01e1dc865012.webp",
      "image_media": {
        "alt_text": "A bedroom with a large window and neutral-colored carpet.",
        "public_id": "019d021c-06d7-7149-8087-01e1dc865012",
        "storage_key": "property/6767906449167172/019d021c-06d7-7149-8087-01e1dc865012.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "This bedroom features a large window that lets in natural light and neutral carpeting for a cozy feel.",
      "link": "false",
      "alt_text": "A bright, open bedroom here at Austin Park featuring soft neutral walls, plush carpet flooring, and a large window with vertical blinds that allows natural light to fill the space, creating a clean, versatile room ideal for a bedroom, guest room, or home office.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(15).jpg"
    },
    {
      "id": "ec_1f736bcb00b0b50492c6f16d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-0004-729f-92c8-196d750ce806.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and doorway to another room.",
        "public_id": "01a16cb0-0004-729f-92c8-196d750ce806",
        "storage_key": "property/6767906449167172/01a16cb0-0004-729f-92c8-196d750ce806.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "A spacious bedroom with plush carpeting and ample closet space, ready for your personal touch.",
      "link": "false",
      "alt_text": "A clean, neutral bedroom here at Austin Park featuring soft beige walls, plush carpet flooring, and a bright ceiling light, with a built-in closet that includes open white doors and a hanging rod, offering practical storage and a simple layout ideal for a bedroom, office, or flex space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(33).jpg"
    },
    {
      "id": "ec_94986ea88cd2d55b8a06759d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16caf-f194-7415-a2e0-128c21b8fe12.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances, and a white countertop.",
        "public_id": "01a16caf-f194-7415-a2e0-128c21b8fe12",
        "storage_key": "property/6767906449167172/01a16caf-f194-7415-a2e0-128c21b8fe12.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Charming kitchen featuring dark wood cabinetry, a black stove and refrigerator, and ample counter space for meal preparation.",
      "link": "false",
      "alt_text": "A bright, efficient kitchen here at Austin Park featuring rich wood cabinetry, black appliances including a refrigerator and electric range, light countertops, a stainless steel sink, and neutral flooring, with overhead lighting and a compact layout that offers practical storage and a clean, functional space for everyday cooking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(30).jpg"
    },
    {
      "id": "ec_2702d1743bba42365bc20fc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-18e6-70c8-9cb6-3b602dbef112.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, wooden cabinets, stainless steel sink, and black stove.",
        "public_id": "01a16cb0-18e6-70c8-9cb6-3b602dbef112",
        "storage_key": "property/6767906449167172/01a16cb0-18e6-70c8-9cb6-3b602dbef112.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this cozy kitchen featuring a black refrigerator, ample wooden cabinetry, a double sink, and a sleek black stove.",
      "link": "false",
      "alt_text": "A warm, functional kitchen here at Austin Park featuring rich wood cabinetry, black appliances including a refrigerator and electric range, light countertops, a stainless sink, a vent hood, and neutral flooring, with a compact layout that offers efficient storage and a clean, practical space for everyday cooking and meal prep.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(29).JPG"
    },
    {
      "id": "ec_40c2282bd3e0c3ae13c97402",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-1a3a-75cd-b24b-f49cffee95db.webp",
      "image_media": {
        "alt_text": "Bathroom with white toilet, white sink, and shower curtain.",
        "public_id": "01a16cb0-1a3a-75cd-b24b-f49cffee95db",
        "storage_key": "property/6767906449167172/01a16cb0-1a3a-75cd-b24b-f49cffee95db.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, sink, and shower with a white curtain. Perfect for any apartment layout.",
      "link": "false",
      "alt_text": "A clean, functional bathroom here at Austin Park featuring a white pedestal sink with chrome fixtures, a wall-mounted mirror with overhead lighting, a standard tub and shower with a textured white curtain, neutral tile flooring, and warm accent towels that add a pop of color to the space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(34).jpg"
    },
    {
      "id": "ec_41747169c05fb261cc9fe551",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-1c0b-7313-bf48-0825d67748ac.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather chairs and a coffee table.",
        "public_id": "01a16cb0-1c0b-7313-bf48-0825d67748ac",
        "storage_key": "property/6767906449167172/01a16cb0-1c0b-7313-bf48-0825d67748ac.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Relax in our comfortable lobby seating area, featuring plush leather chairs and a central coffee table. A 'Switchbacks FC 2017 Partner' banner hangs on the wall.",
      "link": "false",
      "alt_text": "A cozy community lounge living room here at Austin Park featuring three cream leather armchairs arranged around a round wooden coffee table with greenery, soft carpet flooring, large windows with white blinds bringing in natural light, and warm accent walls with framed artwork and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(42).jpg"
    },
    {
      "id": "ec_f029b71e42be54d265349b38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-1d92-7058-ba68-1428637e4732.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding fence.",
        "public_id": "01a16cb0-1d92-7058-ba68-1428637e4732",
        "storage_key": "property/6767906449167172/01a16cb0-1d92-7058-ba68-1428637e4732.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs for sunbathing and relaxation.",
      "link": "false",
      "alt_text": "A bright outdoor pool here at Austin Park featuring a sparkling rectangular swimming pool with clear blue water, surrounding concrete deck with metal handrails, lounge chairs lined along the fence, and landscaped greenery, creating a refreshing community space under a sunny blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(36).jpg"
    },
    {
      "id": "ec_467f025db4deda0c7c197db9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-14a6-773e-93f5-426a64a0a9fb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019d021c-14a6-773e-93f5-426a64a0a9fb",
        "storage_key": "property/6767906449167172/019d021c-14a6-773e-93f5-426a64a0a9fb.webp",
        "width": 3072,
        "height": 2063
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "A sunny outdoor pool here at Austin Park showcasing a clear blue rectangular swimming pool surrounded by a spacious concrete deck, metal handrails, lounge chairs, patio seating with an umbrella, and a secure fence, with mature trees and residential buildings creating a relaxed community setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(18).jpg"
    },
    {
      "id": "ec_ad1a081a4d0517973dbaadd0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-15b5-77cf-ad52-7badc6347709.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and tables outside apartment buildings.",
        "public_id": "019d021c-15b5-77cf-ad52-7badc6347709",
        "storage_key": "property/6767906449167172/019d021c-15b5-77cf-ad52-7badc6347709.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by comfortable lounge chairs and outdoor dining areas.",
      "link": "false",
      "alt_text": "A bright outdoor pool here at Austin Park featuring a clear rectangular swimming pool bordered by a wide concrete deck, metal handrails, and lounge chairs, with patio seating under an umbrella, a secure black fence, mature trees, and multi-story apartment buildings set against a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(19).jpg"
    },
    {
      "id": "ec_80afcbe9c36936b6cc960f3d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-1ca8-7204-bb31-32ab6a52419e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with chairs in the foreground.",
        "public_id": "019d021c-1ca8-7204-bb31-32ab6a52419e",
        "storage_key": "property/6767906449167172/019d021c-1ca8-7204-bb31-32ab6a52419e.webp",
        "width": 800,
        "height": 535
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded seating area.",
      "link": "false",
      "alt_text": "A sunny outdoor pool area here at Austin Park showcasing a sparkling rectangular swimming pool with metal handrails, a wide concrete deck, and woven patio chairs surrounding a round table in the foreground, with lounge seating, manicured greenery, mature trees, and the community clubhouse under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(20).jpg"
    },
    {
      "id": "ec_fc819080a18359d259e68147",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-1f63-72ae-9595-6a7c7473841e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and playground swings at an apartment complex.",
        "public_id": "019d021c-1f63-72ae-9595-6a7c7473841e",
        "storage_key": "property/6767906449167172/019d021c-1f63-72ae-9595-6a7c7473841e.webp",
        "width": 800,
        "height": 534
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling pool or let the kids play on the swings at this community's outdoor recreation area.",
      "link": "false",
      "alt_text": "A sunny outdoor playground area here at Austin Park featuring a simple metal swing set set over a sandy play surface, with neatly trimmed grass, landscaped shrubs, and a fenced community pool with patio seating and nearby apartment buildings visible under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(21).jpg"
    },
    {
      "id": "ec_c105826e694c12c6464aed4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-2e79-706e-890a-52e7f85e0106.webp",
      "image_media": {
        "alt_text": "Picnic tables and a swing set in a grassy courtyard with apartment buildings in the background.",
        "public_id": "01a16cb0-2e79-706e-890a-52e7f85e0106",
        "storage_key": "property/6767906449167172/01a16cb0-2e79-706e-890a-52e7f85e0106.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings and fresh air at our community's picnic areas and playground. Perfect for family fun and relaxation.",
      "link": "false",
      "alt_text": "A bright outdoor picnic and play area here at Austin Park featuring wooden picnic tables on a concrete pad, a small playground with swings and climbing equipment, lush green grass, mature trees, and surrounding apartment buildings with neutral siding and brick accents under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(39).jpg"
    },
    {
      "id": "ec_0111fe95922ac81b20929ef0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-421a-7718-a6ce-ecead2a87f99.webp",
      "image_media": {
        "alt_text": "Austin Park Apartment Homes monument sign with phone number 597-1657.",
        "public_id": "01a16cb0-421a-7718-a6ce-ecead2a87f99",
        "storage_key": "property/6767906449167172/01a16cb0-421a-7718-a6ce-ecead2a87f99.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Welcome to Austin Park Apartment Homes. Call us today at 597-1657 for leasing information.",
      "link": "false",
      "alt_text": "A welcoming exterior community sign here at Austin Park featuring a dark green and gold Austin Park Apartment Homes monument sign with white posts, surrounded by mature trees, green grass, and landscaped walkways, with residential apartment buildings visible in the background beneath a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(40).jpg"
    },
    {
      "id": "ec_58a52e8bc816d063b2025d9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-336d-7189-8686-ef2e59e18fc5.webp",
      "image_media": {
        "alt_text": "Austin Park Apartment Homes signage with landscaping.",
        "public_id": "019d021c-336d-7189-8686-ef2e59e18fc5",
        "storage_key": "property/6767906449167172/019d021c-336d-7189-8686-ef2e59e18fc5.webp",
        "width": 800,
        "height": 534
      },
      "title": "Community",
      "description": "Welcome to Austin Park Apartment Homes. Visit us today at 597-1657.",
      "link": "false",
      "alt_text": "A bright landscaped community sign here at Austin Park displaying the Austin Park Apartment Homes monument sign with white posts and dark green lettering, surrounded by colorful flowers, manicured shrubs, and mature trees, with apartment buildings and a sidewalk visible under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(28).JPG"
    },
    {
      "id": "ec_32be747e837086bc6663768b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-2514-76be-85b2-c9f7fbf2bc74.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with parking lot and cars.",
        "public_id": "019d021c-2514-76be-85b2-c9f7fbf2bc74",
        "storage_key": "property/6767906449167172/019d021c-2514-76be-85b2-c9f7fbf2bc74.webp",
        "width": 3072,
        "height": 1853
      },
      "title": "Community",
      "description": "Exterior view of an apartment building, showcasing the facade and surrounding parking area with vehicles.",
      "link": "false",
      "alt_text": "A bright exterior view of apartment buildings here at Austin Park featuring light gray siding with white trim, peaked rooflines, large windows, a central stairwell entrance, landscaped shrubs, and an adjacent parking area under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(23).jpg"
    },
    {
      "id": "ec_dda8ca7cfc7cb3ba6eb38816",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-451a-708c-9e4f-cfafbbacc12c.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with green grass and trees.",
        "public_id": "01a16cb0-451a-708c-9e4f-cfafbbacc12c",
        "storage_key": "property/6767906449167172/01a16cb0-451a-708c-9e4f-cfafbbacc12c.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Charming apartment buildings with lush green lawns and mature trees. Enjoy the peaceful surroundings and well-maintained grounds.",
      "link": "false",
      "alt_text": "A sunlit exterior view here at Austin Park showcasing two-story apartment buildings with neutral siding, brick accents, large windows, manicured green lawns, mature trees, trimmed shrubs, and a peaceful residential setting under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(41).jpg"
    },
    {
      "id": "ec_0869c980b5312e1766e28ec2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a16cb0-4710-737f-a835-4de14c8e7e01.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a large lawn and mountains in the background.",
        "public_id": "01a16cb0-4710-737f-a835-4de14c8e7e01",
        "storage_key": "property/6767906449167172/01a16cb0-4710-737f-a835-4de14c8e7e01.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with lush green lawns, mature trees, and stunning mountain views. Enjoy the serene atmosphere and spacious outdoor areas.",
      "link": "false",
      "alt_text": "A scenic exterior view here at Austin Park featuring two-story apartment buildings with neutral siding and brick accents, expansive green lawns, mature pine trees, trimmed shrubs, and a paved walkway, with mountain views in the distance under a bright blue sky with soft clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Austin-Park_Favorites%20(38).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cac07be7-86cb-40ff-8100-dcbd629dd87a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Wooglin's Deli & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4750 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Familiar, longtime fixture serving locally roasted coffee along with hefty sandwiches & baked goods.",
      "poi_long_description": "Familiar, longtime fixture serving locally roasted coffee along with hefty sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-80de-716a-a67e-30a7c99fd8ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-80de-716a-a67e-30a7c99fd8ec",
        "storage_key": "property/6767906449167172/01a140d7-80de-716a-a67e-30a7c99fd8ec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wooglinsdeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8889231921397658725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wooglins-deli--cafe",
      "poi_latitude": "38.897461199999995",
      "poi_longitude": "-104.7390707",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-578-9443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fUQBUBFE4cRZXT42FXlXHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_65419fdf-ca0b-4c39-9c6c-81bcc8724f2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Rizuto's Ice Cream Inc.",
      "poi_type": "Restaurants",
      "poi_address": "4785 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Unassuming, family-owned ice cream parlor with a variety of flavors, plus gelato & soft-serve.",
      "poi_long_description": "Unassuming, family-owned ice cream parlor with a variety of flavors, plus gelato & soft-serve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-7bb6-7634-80fc-54c143f8bceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-7bb6-7634-80fc-54c143f8bceb",
        "storage_key": "property/6767906449167172/01a140d7-7bb6-7634-80fc-54c143f8bceb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.rizutosicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9776686703974070682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rizutos-ice-cream-inc",
      "poi_latitude": "38.896220799999995",
      "poi_longitude": "-104.7392606",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-596-7191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dcb3-717c-83a9-50c6a0e874b8",
        "storage_key": "property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVYPZDLhIE4cRmrmoFsLErYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_c5ba9f5a-6138-4f0c-af49-ee89d7fa7bb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "New China Kitchen 2",
      "poi_type": "Restaurants",
      "poi_address": "4795 Barnes Rd H, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Casual dining room with full sit-down service, takeout & delivery of a mix of classic Chinese eats.",
      "poi_long_description": "Casual dining room with full sit-down service, takeout & delivery of a mix of classic Chinese eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-7da7-7630-a670-04da3cc3765e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-7da7-7630-a670-04da3cc3765e",
        "storage_key": "property/6767906449167172/01a140d7-7da7-7630-a670-04da3cc3765e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newchinakitchen2.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10589654799158768971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-china-kitchen-2",
      "poi_latitude": "38.8965422",
      "poi_longitude": "-104.7389628",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-638-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQAhbbhIE4cRS3Xe9e4C9pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_63a0fb8e-c7b9-4532-a843-f42891ee5ae9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "La Conchita Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "4785 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Family-operated Mexican eatery featuring authentic street tacos and traditional tamales.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-788b-73d7-9a2b-0515f3e5ff69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-788b-73d7-9a2b-0515f3e5ff69",
        "storage_key": "property/6767906449167172/01a140d7-788b-73d7-9a2b-0515f3e5ff69.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://laconchitacos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=398575901149765331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-conchita-mexican-food",
      "poi_latitude": "38.8961715",
      "poi_longitude": "-104.7389373",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-204-5355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Td0CgpJE4cR0x4QnKsGiAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a5982184-f57a-45d0-833d-8ac46281e53d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Barnes Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4829 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Casual neighborhood bar and grill serving affordable pub food and signature wings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-7c70-722e-93dd-858197f3bfb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-7c70-722e-93dd-858197f3bfb3",
        "storage_key": "property/6767906449167172/01a140d7-7c70-722e-93dd-858197f3bfb3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7044053483530284598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnes-bar--grill",
      "poi_latitude": "38.8962326",
      "poi_longitude": "-104.7375183",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-358-8956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9TB_N5JE4cRNu6sgFKBwWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dbbf92cc-e510-4f97-b728-e028f0ae40a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Phở Express #1",
      "poi_type": "Restaurants",
      "poi_address": "5697 Barnes Rd #110, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Welcoming Vietnamese restaurant serving flavorful phở and assorted boba teas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-80d3-7228-8666-a20f994b2c36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-80d3-7228-8666-a20f994b2c36",
        "storage_key": "property/6767906449167172/01a140d7-80d3-7228-8666-a20f994b2c36.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phoexpress1.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1593839458425515009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ph-express-1",
      "poi_latitude": "38.8921508",
      "poi_longitude": "-104.7208251",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-591-2723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtSvqAf9JE4cRASx0_Ip0HhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0ebe8a6b-877a-49a1-80b8-cf808210a7c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Tokyo Joe's - Powers",
      "poi_type": "Restaurants",
      "poi_address": "5697 Barnes Rd #120, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Branch of a stylish counter-order chain serving noodle bowls & other health-minded Japanese bites.",
      "poi_long_description": "Branch of a stylish counter-order chain serving noodle bowls & other health-minded Japanese bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-7a81-74fd-a5e8-eb7c4c0c9f90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-7a81-74fd-a5e8-eb7c4c0c9f90",
        "storage_key": "property/6767906449167172/01a140d7-7a81-74fd-a5e8-eb7c4c0c9f90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tokyojoes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5079019597281752312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokyo-joes---powers",
      "poi_latitude": "38.8921852",
      "poi_longitude": "-104.720848",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-313-5386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-Db_5NIE4cR-PQ592lNfEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_eb92f319-facc-48da-9251-7622eca526dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Parry's Sliceria & Taps",
      "poi_type": "Restaurants",
      "poi_address": "5697 Barnes Rd #130, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Casual pizza restaurant serving NY-style slices, wings, and a wide selection of craft beers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-7cf1-749f-bb5c-65cb4066b06b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-7cf1-749f-bb5c-65cb4066b06b",
        "storage_key": "property/6767906449167172/01a140d7-7cf1-749f-bb5c-65cb4066b06b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parryspizza.com/locations/colorado-springs-sliceria/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15718321286130826012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parrys-sliceria--taps",
      "poi_latitude": "38.892249199999995",
      "poi_longitude": "-104.7208804",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-985-8951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3DXcHRJE4cRHPtJNe6xIto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_2149eef1-7ee8-48f3-a2ae-1d79610d19c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Cheba Hut \"Toasted\" Subs",
      "poi_type": "Restaurants",
      "poi_address": "5697 Barnes Rd #100, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Laid-back sandwich-shop chain for creative toasted subs, plus snacks & desserts.",
      "poi_long_description": "Laid-back sandwich-shop chain for creative toasted subs, plus snacks & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-784c-72c4-801d-82b65ee66dd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-784c-72c4-801d-82b65ee66dd4",
        "storage_key": "property/6767906449167172/01a140d7-784c-72c4-801d-82b65ee66dd4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chebahut.com/locations/colorado-springs-powers/?utm_source=google&utm_medium=GBP&utm_campaign=Colorado+Springs-Powers",
      "poi_directions_map_url": "https://maps.google.com/?cid=8111291953673399395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheba-hut-toasted-subs",
      "poi_latitude": "38.8920416",
      "poi_longitude": "-104.720781",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-999-5970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9eCUJ5JE4cRY-wvcA4ZkXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_9e200fd2-a33d-447e-9762-d55ac6d8e85c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "5707 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-784e-7492-8bcf-7410d472c42b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-784e-7492-8bcf-7410d472c42b",
        "storage_key": "property/6767906449167172/01a140d7-784e-7492-8bcf-7410d472c42b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/co/colorado-springs/colorado-springs/5568?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:colorado-springs-co-5568_pl:locurl_rd:1492",
      "poi_directions_map_url": "https://maps.google.com/?cid=9903462172767102423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "38.8927114",
      "poi_longitude": "-104.7209029",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-597-6352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-Db_5NIE4cR1yVNFmAqcIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ead46afb-3901-4755-992a-844ac7ad59cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Rhino's Sports & Spirits",
      "poi_type": "Restaurants",
      "poi_address": "4307 Integrity Center Point, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Easygoing sports fan hangout offering bar bites, billiards, game nights & flat-screens galore.",
      "poi_long_description": "Easygoing sports fan hangout offering bar bites, billiards, game nights & flat-screens galore.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8328-70de-9b9c-955ede07b383.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8328-70de-9b9c-955ede07b383",
        "storage_key": "property/6767906449167172/01a140d7-8328-70de-9b9c-955ede07b383.webp",
        "width": 550,
        "height": 367
      },
      "poi_business_url": "https://www.rhinossportsbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18170093890946664283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rhinos-sports--spirits",
      "poi_latitude": "38.8943294",
      "poi_longitude": "-104.7212898",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-578-0608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021d-54c8-7577-9f2f-3080c14ad8a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-54c8-7577-9f2f-3080c14ad8a1",
        "storage_key": "property/6767906449167172/019d021d-54c8-7577-9f2f-3080c14ad8a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzaLZJFIE4cRWwdf4R8kKfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_5e0d76a7-6054-4cc6-af21-749f4207a100",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "5838 Barnes Rd, Colorado Springs, CO 80922, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-85e9-7491-beb5-60fdd61e6b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-85e9-7491-beb5-60fdd61e6b3e",
        "storage_key": "property/6767906449167172/01a140d7-85e9-7491-beb5-60fdd61e6b3e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.firstwatch.com/locations/barnes/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=barnes",
      "poi_directions_map_url": "https://maps.google.com/?cid=7421548556846917241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "38.8948537",
      "poi_longitude": "-104.7186686",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-574-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a5-77bd-a840-8914631d5e83",
        "storage_key": "property/6767906449167172/019d021c-d7a5-77bd-a840-8914631d5e83.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFxH5HhpJE4cReWYsZhej_mY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_179602dd-4bac-4902-b908-48ba1946d09a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "5808 Barnes Rd, Colorado Springs, CO 80922, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-844d-7592-aee4-d2656f1082c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-844d-7592-aee4-d2656f1082c5",
        "storage_key": "property/6767906449167172/01a140d7-844d-7592-aee4-d2656f1082c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/91238/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995355134118873323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "38.8942126",
      "poi_longitude": "-104.7174719",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-638-2624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7d4-7000-ba9b-20f9abd7fe35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7d4-7000-ba9b-20f9abd7fe35",
        "storage_key": "property/6767906449167172/01a140d7-c7d4-7000-ba9b-20f9abd7fe35.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJFXfTlZFIE4cR60hM2Z-jkSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_91af6805-9c63-4b23-b1d4-fab92c19a944",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4142 Austin Bluffs Pkwy, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Convenient neighborhood grocery store offering quick service and an on-site pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8703-7115-85e9-f1e3f8922a50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8703-7115-85e9-f1e3f8922a50",
        "storage_key": "property/6767906449167172/01a140d7-8703-7115-85e9-f1e3f8922a50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3175-colorado-springs-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2433452183519434846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "38.8927982",
      "poi_longitude": "-104.7555578",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-244-9776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc22-7658-95cc-b556df40765c",
        "storage_key": "property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ZAdnktPE4cRXhiTMN5bxSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_593130e8-4fdf-4e9c-928d-4ce68ed2ea89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3475 N Academy Blvd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-6c93-7038-92f0-5a8ded0666ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-6c93-7038-92f0-5a8ded0666ae",
        "storage_key": "property/6767906449167172/019d021c-6c93-7038-92f0-5a8ded0666ae.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/colorado-springs-co-pharmacies/3475-north-academy-blvd-colorado-springs-co-80917/storeid=11001?WT.mc_id=LS_GOOGLE_RX_11001",
      "poi_directions_map_url": "https://maps.google.com/?cid=15613921515195453565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.8819866",
      "poi_longitude": "-104.7565025",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-591-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7a6-776f-9b79-18e49c0263da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7a6-776f-9b79-18e49c0263da",
        "storage_key": "property/6767906449167172/019d021c-d7a6-776f-9b79-18e49c0263da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTdqoFxPE4cRfdANWOTKr9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_09d46f1b-72de-4d8d-9614-2909c4537ea3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3480 N Academy Blvd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-895a-72cf-a4c1-a5a40db8a21f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-895a-72cf-a4c1-a5a40db8a21f",
        "storage_key": "property/6767906449167172/01a140d7-895a-72cf-a4c1-a5a40db8a21f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3480+n+academy+blvd-colorado+springs-co-80917/id=3586",
      "poi_directions_map_url": "https://maps.google.com/?cid=8153978968012989886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.88170530000001",
      "poi_longitude": "-104.757739",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-380-9438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAU271lNPE4cRvqVrdqvAKHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_1047c3f4-9872-4933-b4d6-acbc3cac6799",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "3502 N Academy Blvd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8b51-70da-b06f-60322391c78d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8b51-70da-b06f-60322391c78d",
        "storage_key": "property/6767906449167172/01a140d7-8b51-70da-b06f-60322391c78d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/co/colorado-springs/3502-n-academy-blvd-35822?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8888841696262335715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "38.8825931",
      "poi_longitude": "-104.7580417",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-574-3095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7ee-77f6-9228-7ffb1cd597bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7ee-77f6-9228-7ffb1cd597bf",
        "storage_key": "property/6767906449167172/019d021c-d7ee-77f6-9228-7ffb1cd597bf.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJCX0BKVJPE4cR46xlem2CW3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_e1cd95fd-07d7-422d-a695-e832d8e1a4b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "De Mi País Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3572 N Academy Blvd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Grocery or marketplace selling a broad range of Latin American items alongside beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8aab-775d-b0c1-5f23742c19f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8aab-775d-b0c1-5f23742c19f1",
        "storage_key": "property/6767906449167172/01a140d7-8aab-775d-b0c1-5f23742c19f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.demipaismarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11801157522711828187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "de-mi-pas-market",
      "poi_latitude": "38.8833044",
      "poi_longitude": "-104.7574592",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-755-4378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc22-7658-95cc-b556df40765c",
        "storage_key": "property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8X86kFNPE4cR29aq3z0ixqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_76d292d0-b9a6-4cf7-a0a8-244c426a07fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "King Soopers",
      "poi_type": "Shopping & Retail",
      "poi_address": "3620 Austin Bluffs Pkwy, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Well-stocked grocery store offering a wide selection of fresh produce and diverse food items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-7311-7179-bf79-801cc1ea32de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-7311-7179-bf79-801cc1ea32de",
        "storage_key": "property/6767906449167172/019d021c-7311-7179-bf79-801cc1ea32de.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/colorado-springs/academy-and-austin-bluffs/620/00130?cid=loc_62000130_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13897274317546881761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers",
      "poi_latitude": "38.8920767",
      "poi_longitude": "-104.760974",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-598-1891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc22-7658-95cc-b556df40765c",
        "storage_key": "property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJObSX6klPE4cR4YKKY1wJ3cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_241530fc-6fc2-4411-9300-e05799cb233c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Veterans Liquor LLC",
      "poi_type": "Shopping & Retail",
      "poi_address": "3630 Austin Bluffs Pkwy #170, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Local liquor store featuring a wide selection of craft beers and spirits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8c2e-762a-bc2e-ccb38d2922bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8c2e-762a-bc2e-ccb38d2922bb",
        "storage_key": "property/6767906449167172/01a140d7-8c2e-762a-bc2e-ccb38d2922bb.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://m.facebook.com/VeteransWinelq/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13342422433639406810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veterans-liquor-llc",
      "poi_latitude": "38.8930362",
      "poi_longitude": "-104.7600149",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-266-1179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dcb3-717c-83a9-50c6a0e874b8",
        "storage_key": "property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB8V6nEhPE4cR2pxHIIPOKbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_94c92a91-ef74-469c-a905-f780c5c1e9e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "India Bazaar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3659 Austin Bluffs Pkwy #35, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Specialty Indian grocery store offering a wide selection of spices and traditional food items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8ed9-77ea-a427-5f19029139ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8ed9-77ea-a427-5f19029139ba",
        "storage_key": "property/6767906449167172/01a140d7-8ed9-77ea-a427-5f19029139ba.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/pages/India-Bazaar/107102132681548",
      "poi_directions_map_url": "https://maps.google.com/?cid=2062398125372349192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "india-bazaar",
      "poi_latitude": "38.890102899999995",
      "poi_longitude": "-104.7594319",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-264-6995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc22-7658-95cc-b556df40765c",
        "storage_key": "property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04XnKElPE4cRCBtAACscnxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3101e91f-a9c5-4f0b-8f21-25567f977604",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "The Promenade Shops At Briargate",
      "poi_type": "Shopping & Retail",
      "poi_address": "1605-1925 Briargate Pkwy, Colorado Springs, CO 80920, USA",
      "poi_short_description": "Top fashion, electronics & other brands are joined by numerous eateries in an upscale strip setting.",
      "poi_long_description": "Top fashion, electronics & other brands are joined by numerous eateries in an upscale strip setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8c88-7328-93dd-c30fd92d7afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8c88-7328-93dd-c30fd92d7afe",
        "storage_key": "property/6767906449167172/01a140d7-8c88-7328-93dd-c30fd92d7afe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thepromenadeshopsatbriargate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14850808285862625737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-promenade-shops-at-briargate",
      "poi_latitude": "38.9635296",
      "poi_longitude": "-104.7942922",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-265-6264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dcb3-717c-83a9-50c6a0e874b8",
        "storage_key": "property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ84Q7sDNME4cRyQFF-nOrGM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d4cd90e6-9ca9-4e5c-bc1b-364894a1cba6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Colorado Ranch Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3333 N Academy Blvd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9063-75ff-a461-0d873c5983b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9063-75ff-a461-0d873c5983b8",
        "storage_key": "property/6767906449167172/01a140d7-9063-75ff-a461-0d873c5983b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17854354459212653669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-ranch-market",
      "poi_latitude": "38.8807029",
      "poi_longitude": "-104.7551932",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-400-6489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc22-7658-95cc-b556df40765c",
        "storage_key": "property/6767906449167172/019d021c-dc22-7658-95cc-b556df40765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4iOjxdPE4cRZSRIw8hox_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6fdb25d6-24a6-463e-9531-85e048a72977",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Carver Elementary School",
      "poi_type": "Education",
      "poi_address": "4740 Artistic Cir, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-8fb1-7378-a854-240ab00821e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-8fb1-7378-a854-240ab00821e0",
        "storage_key": "property/6767906449167172/01a140d7-8fb1-7378-a854-240ab00821e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://carver.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14718234300051523409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carver-elementary-school",
      "poi_latitude": "38.8888653",
      "poi_longitude": "-104.7421583",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-328-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNxDAV7BIE4cRUYeKhx2sQcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_17ba9ab4-ed89-451e-acc7-0f8814fa9692",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Sabin Middle School",
      "poi_type": "Education",
      "poi_address": "3605 Carefree Cir N, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9198-7596-bfaa-5e474fb6f365.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9198-7596-bfaa-5e474fb6f365",
        "storage_key": "property/6767906449167172/01a140d7-9198-7596-bfaa-5e474fb6f365.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sabin.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6946964062093002506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sabin-middle-school",
      "poi_latitude": "38.8820438",
      "poi_longitude": "-104.7503498",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-328-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu4psjqxIE4cRCkd1BAKTaGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_84e3155c-07ac-41a9-9cca-dd5307754d14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Doherty High School",
      "poi_type": "Education",
      "poi_address": "4515 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-86c6-7200-bf20-5a8443d7ebaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-86c6-7200-bf20-5a8443d7ebaf",
        "storage_key": "property/6767906449167172/019d021c-86c6-7200-bf20-5a8443d7ebaf.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://doherty.d11.org/?utm_source=cumulus&utm_medium=onlinepresence&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14230171187691910255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doherty-high-school",
      "poi_latitude": "38.8959683",
      "poi_longitude": "-104.743779",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-328-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJncQYMbZIE4cRb_Rf70y5e8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_77b1662f-0cd4-45cb-8a7f-6122f92b900e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Penrose Elementary School",
      "poi_type": "Education",
      "poi_address": "4285 Nonchalant Cir S, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9479-776d-a960-6dd6b6526f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9479-776d-a960-6dd6b6526f2d",
        "storage_key": "property/6767906449167172/01a140d7-9479-776d-a960-6dd6b6526f2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://penrose.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3402981981385298630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penrose-elementary-school",
      "poi_latitude": "38.8785051",
      "poi_longitude": "-104.7468143",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-328-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7fThLKpIE4cRxpKGERXSOS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_693bd964-cdc9-4262-9ba8-164cace8f00d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Rudy Elementary School",
      "poi_type": "Education",
      "poi_address": "5370 Cracker Barrel Cir, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rudy.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4682707995720075599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rudy-elementary-school",
      "poi_latitude": "38.8911616",
      "poi_longitude": "-104.7263621",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-328-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk3I9UpZIE4cRT8nGrxxS_EA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f4be390f-0331-4d72-89d5-0213746139d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Russell Middle School",
      "poi_type": "Education",
      "poi_address": "3825 Montebello Dr W, Colorado Springs, CO 80918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://russell.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577056193968958079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russell-middle-school",
      "poi_latitude": "38.9040141",
      "poi_longitude": "-104.7573899",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-328-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHzHdIDJPE4cRf2rdmpFAyZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b18e6dec-6727-410b-bc30-bbaed06fe276",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Creative Play Centers & Adventure Clubs",
      "poi_type": "Education",
      "poi_address": "3580 N Carefree Cir, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.advclubchildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13772333812686550140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creative-play-centers--adventure-clubs",
      "poi_latitude": "38.882563",
      "poi_longitude": "-104.755301",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-596-5617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU52XVFJPE4cRfHRIOaIoIb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_32363604-f972-4a41-b96f-c3dc3d3afd62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "La Petite Academy on Rio Vista Dr",
      "poi_type": "Education",
      "poi_address": "3615 Rio Vista Dr, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Nurturing day care and preschool featuring hands-on learning programs and real-time family communication.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9577-70af-a816-bcb9d6ba62f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9577-70af-a816-bcb9d6ba62f2",
        "storage_key": "property/6767906449167172/01a140d7-9577-70af-a816-bcb9d6ba62f2.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/colorado-springs-co-7258/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7258",
      "poi_directions_map_url": "https://maps.google.com/?cid=17629639573301024559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-rio-vista-dr",
      "poi_latitude": "38.8842262",
      "poi_longitude": "-104.7218799",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAzIo9ptIE4cRL9fGPMkPqfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_10668118-bd04-4ea2-baa2-fff71416a5f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "University of Colorado Colorado Springs",
      "poi_type": "Education",
      "poi_address": "1420 Austin Bluffs Pkwy, Colorado Springs, CO 80918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d5-86f7-7269-9f0d-28e1ace25aa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d5-86f7-7269-9f0d-28e1ace25aa6",
        "storage_key": "property/6767906449167172/01a140d5-86f7-7269-9f0d-28e1ace25aa6.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.uccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577512112395933892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-colorado-colorado-springs",
      "poi_latitude": "38.8928151",
      "poi_longitude": "-104.8007996",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-255-8227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTn-iKBPE4cRxFjAYjnfypI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9dac1c33-7419-411b-892b-98ea5d361ed6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Colorado School for the Deaf and the Blind",
      "poi_type": "Education",
      "poi_address": "33 N Institute St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9514-723a-a9cc-c2ea1df8d58e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9514-723a-a9cc-c2ea1df8d58e",
        "storage_key": "property/6767906449167172/01a140d7-9514-723a-a9cc-c2ea1df8d58e.webp",
        "width": 1280,
        "height": 920
      },
      "poi_business_url": "http://www.csdb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12126175768315287230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-school-for-the-deaf-and-the-blind",
      "poi_latitude": "38.8348005",
      "poi_longitude": "-104.807293",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-578-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvdR4JwRFE4cRvtZhMp3USKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_06c09f87-d7fc-4f12-9b45-91a777aaaba3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Regal Interquest",
      "poi_type": "Entertainment",
      "poi_address": "1120 Interquest Pkwy, Colorado Springs, CO 80920, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-978e-752b-b8d1-47d77378e693.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-978e-752b-b8d1-47d77378e693",
        "storage_key": "property/6767906449167172/01a140d7-978e-752b-b8d1-47d77378e693.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-interquest-rpx-1609?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15948113296100753137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-interquest",
      "poi_latitude": "38.9942523",
      "poi_longitude": "-104.8106545",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e176-7119-b597-f94ec69a417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e176-7119-b597-f94ec69a417f",
        "storage_key": "property/6767906449167172/019d021c-e176-7119-b597-f94ec69a417f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7l8hwhNE4cR8f7Ey4sUU90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7777bc79-585e-462a-9113-29885c131197",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Icon Cinema",
      "poi_type": "Entertainment",
      "poi_address": "1818 Spring Water Pt, Colorado Springs, CO 80921, USA",
      "poi_short_description": "Affordable movie theater featuring reclining seats and unlimited self-serve popcorn and drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-a7dc-708e-98d1-80676fe652da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-a7dc-708e-98d1-80676fe652da",
        "storage_key": "property/6767906449167172/01a140d7-a7dc-708e-98d1-80676fe652da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.iconcinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14193515563878498816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "icon-cinema",
      "poi_latitude": "38.9881275",
      "poi_longitude": "-104.7935421",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-598-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e176-7119-b597-f94ec69a417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e176-7119-b597-f94ec69a417f",
        "storage_key": "property/6767906449167172/019d021c-e176-7119-b597-f94ec69a417f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxz4GlRME4cRAML0cjR_-cQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b76f37c0-7140-46f0-b230-0016a3916f6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Picture Show at Citadel Crossing",
      "poi_type": "Entertainment",
      "poi_address": "901 N Academy Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Family-friendly movie theater with digital projection,  multiple screens & 3D capability.",
      "poi_long_description": "Family-friendly movie theater with digital projection,  multiple screens & 3D capability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-92a7-7049-9a63-2790ffebd741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-92a7-7049-9a63-2790ffebd741",
        "storage_key": "property/6767906449167172/019d021c-92a7-7049-9a63-2790ffebd741.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.pictureshowent.com/movie-theater/citadel-crossing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9659494593231972232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "picture-show-at-citadel-crossing",
      "poi_latitude": "38.8459694",
      "poi_longitude": "-104.755053",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-570-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e176-7119-b597-f94ec69a417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e176-7119-b597-f94ec69a417f",
        "storage_key": "property/6767906449167172/019d021c-e176-7119-b597-f94ec69a417f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq99HsNlFE4cRiOdlgydrDYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_63dc631d-02d2-45fe-b95e-f992fabb9bed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Ent Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "5225 N Nevada Ave, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Modern arts complex hosting live theater and musical performances with excellent acoustics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-929e-7446-83bb-11072270fe7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-929e-7446-83bb-11072270fe7d",
        "storage_key": "property/6767906449167172/019d021c-929e-7446-83bb-11072270fe7d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://entcenterforthearts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17475848600161142008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ent-center-for-the-arts",
      "poi_latitude": "38.9041936",
      "poi_longitude": "-104.8148193",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-255-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d5-b30c-76f8-853d-69373788d296.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d5-b30c-76f8-853d-69373788d296",
        "storage_key": "property/6767906449167172/01a140d5-b30c-76f8-853d-69373788d296.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0kIk7NPE4cR-MQc-bWvhvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_1d66aec9-b312-4a17-86ce-c1b242e3624c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Ford Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "95 Spectrum Lp, Colorado Springs, CO 80921, USA",
      "poi_short_description": "Modern event venue featuring scenic mountain views and concert seating with fire pit options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-98fc-705e-aa0b-6a3d402b8746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-98fc-705e-aa0b-6a3d402b8746",
        "storage_key": "property/6767906449167172/01a140d7-98fc-705e-aa0b-6a3d402b8746.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fordamphitheater.live/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7601051939394716149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ford-amphitheater",
      "poi_latitude": "39.0181842",
      "poi_longitude": "-104.8238685",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d5-b30c-76f8-853d-69373788d296.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d5-b30c-76f8-853d-69373788d296",
        "storage_key": "property/6767906449167172/01a140d5-b30c-76f8-853d-69373788d296.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8WxAABNE4cR9YHqfndcfGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_5eea4705-8023-4bc0-a089-b9dbcb22ba1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Pikes Peak Center For The Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "190 S Cascade Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Performing arts theater hosting diverse concerts, symphonies, and live performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-9bfc-700e-a9fb-0a59bc8c8e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-9bfc-700e-a9fb-0a59bc8c8e24",
        "storage_key": "property/6767906449167172/019d021c-9bfc-700e-a9fb-0a59bc8c8e24.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pikespeakcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500179945342731688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-center-for-the-performing-arts",
      "poi_latitude": "38.8309234",
      "poi_longitude": "-104.8265795",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-477-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7ed-7592-ba2a-b14666ae8874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7ed-7592-ba2a-b14666ae8874",
        "storage_key": "property/6767906449167172/01a140d7-c7ed-7592-ba2a-b14666ae8874.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJScDMxCNFE4cRqIU5z7rYmJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_27d53e49-22b5-4c3d-aefe-87b47e77dc79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Lulu's Downtown",
      "poi_type": "Entertainment",
      "poi_address": "32 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Intimate live music venue featuring frequent concerts and eclectic atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9a25-764d-a51a-7b780d05f185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9a25-764d-a51a-7b780d05f185",
        "storage_key": "property/6767906449167172/01a140d7-9a25-764d-a51a-7b780d05f185.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lulusmusic.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16313143209268049895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lulus-downtown",
      "poi_latitude": "38.8326966",
      "poi_longitude": "-104.8240027",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7ed-7592-ba2a-b14666ae8874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7ed-7592-ba2a-b14666ae8874",
        "storage_key": "property/6767906449167172/01a140d7-c7ed-7592-ba2a-b14666ae8874.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa_VDxqdRE4cR53d_blHtY-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_76854b1e-f0c0-4a81-a938-3a695de35b01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Fine Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "30 W Dale St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Historic cultural center with renowned American art collection, large performance theater & classes.",
      "poi_long_description": "Historic cultural center with renowned American art collection, large performance theater & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-9da4-76a6-9927-1df4a24f3f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-9da4-76a6-9927-1df4a24f3f25",
        "storage_key": "property/6767906449167172/019d021c-9da4-76a6-9927-1df4a24f3f25.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://fac.coloradocollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13047541867328776338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fine-arts-center",
      "poi_latitude": "38.8457835",
      "poi_longitude": "-104.8261714",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 719-634-5581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7ed-7592-ba2a-b14666ae8874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7ed-7592-ba2a-b14666ae8874",
        "storage_key": "property/6767906449167172/01a140d7-c7ed-7592-ba2a-b14666ae8874.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2B2mkBFE4cRkigrEjMuErU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6f074bc7-bb3d-4deb-8588-ab96413e1827",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4250 Cheyenne Mountain Zoo Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_long_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9e86-7165-8d6d-d22c5b1c4aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9e86-7165-8d6d-d22c5b1c4aa8",
        "storage_key": "property/6767906449167172/01a140d7-9e86-7165-8d6d-d22c5b1c4aa8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10507210585571489614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-zoo",
      "poi_latitude": "38.7703872",
      "poi_longitude": "-104.8548688",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 719-633-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7dc-714f-a872-3c702d69258f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7dc-714f-a872-3c702d69258f",
        "storage_key": "property/6767906449167172/01a140d7-c7dc-714f-a872-3c702d69258f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk6vByq9cE4cRTnc2pVsc0ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_ac04b6f9-884b-44bd-b6fb-8697e0a0e3a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Ghost Town Museum",
      "poi_type": "Entertainment",
      "poi_address": "400 21st St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "A model town of historic structures & artifacts, with gold panning & other activities for kids.",
      "poi_long_description": "A model town of historic structures & artifacts, with gold panning & other activities for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9c2a-7153-9099-ba453a5e594d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9c2a-7153-9099-ba453a5e594d",
        "storage_key": "property/6767906449167172/01a140d7-9c2a-7153-9099-ba453a5e594d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.ghosttownmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14978692687655113610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ghost-town-museum",
      "poi_latitude": "38.8404749",
      "poi_longitude": "-104.8607719",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 719-634-0696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e1b5-7038-87fe-9463165f5a2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e1b5-7038-87fe-9463165f5a2a",
        "storage_key": "property/6767906449167172/019d021c-e1b5-7038-87fe-9463165f5a2a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57p3fMdaE4cRipNsj6MB388",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_dbeaab20-f472-4f00-b1bf-ba1cf5051336",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "UCHealth Urgent Care - Powers",
      "poi_type": "Health and Wellness",
      "poi_address": "4323 Integrity Center Point, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9c82-7328-883c-5ee7d8866506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9c82-7328-883c-5ee7d8866506",
        "storage_key": "property/6767906449167172/01a140d7-9c82-7328-883c-5ee7d8866506.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-urgent-care-powers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1561280481475930852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-urgent-care---powers",
      "poi_latitude": "38.8942376",
      "poi_longitude": "-104.7210597",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-591-2558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97sOY5FIE4cR5KofbVPIqhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5a621c95-e888-4d23-aeb6-2cd80c3beb09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Convenient Care Center - Peak Vista Community Health Centers",
      "poi_type": "Health and Wellness",
      "poi_address": "3205 N Academy Blvd Ste. 100, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9e26-778e-bd92-52049d166c1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9e26-778e-bd92-52049d166c1b",
        "storage_key": "property/6767906449167172/01a140d7-9e26-778e-bd92-52049d166c1b.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "https://www.peakvista.org/location/convenient-care-center-colorado-springs-co-80917",
      "poi_directions_map_url": "https://maps.google.com/?cid=2495710362353597491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "convenient-care-center---peak-vista-community-health-centers",
      "poi_latitude": "38.8782299",
      "poi_longitude": "-104.7560217",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-632-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wG4Q1RPE4cRM_xYClqLoiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_c2ca73d3-cee1-41c0-a24c-a65436c226ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Soluna Mind and Body",
      "poi_type": "Health and Wellness",
      "poi_address": "3945 N Academy Blvd Ste I, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-9ee9-70eb-9e26-6a41d71782dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-9ee9-70eb-9e26-6a41d71782dc",
        "storage_key": "property/6767906449167172/01a140d7-9ee9-70eb-9e26-6a41d71782dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.solunaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12930787185926177078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soluna-mind-and-body",
      "poi_latitude": "38.8889211",
      "poi_longitude": "-104.7553088",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 719-695-7117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3ZKY21PE4cRNoFNc29ic7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_a5941670-cea0-4dd1-82f5-bd345bdf7e85",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "The House of Flow",
      "poi_type": "Health and Wellness",
      "poi_address": "4841 Barnes Rd, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-a039-728e-be63-c08dfada0048.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-a039-728e-be63-c08dfada0048",
        "storage_key": "property/6767906449167172/01a140d7-a039-728e-be63-c08dfada0048.webp",
        "width": 1062,
        "height": 1280
      },
      "poi_business_url": "http://www.thehouseofflowco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8239518278190434407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-house-of-flow",
      "poi_latitude": "38.896131",
      "poi_longitude": "-104.7370259",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-666-2785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7uZ1JpJE4cRZwjhGzimWHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_fe6d0d90-ffee-4af6-b4bf-2cf132b84761",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Rustic Hills",
      "poi_type": "Shopping & Retail",
      "poi_address": "N Academy Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Convenient shopping mall featuring diverse retail stores and dining options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-a393-769c-a988-f8fa0e5fabaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-a393-769c-a988-f8fa0e5fabaf",
        "storage_key": "property/6767906449167172/01a140d7-a393-769c-a988-f8fa0e5fabaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18022542956881604623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rustic-hills",
      "poi_latitude": "38.8552627",
      "poi_longitude": "-104.7540359",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dcb3-717c-83a9-50c6a0e874b8",
        "storage_key": "property/6767906449167172/019d021c-dcb3-717c-83a9-50c6a0e874b8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjTW9HeFFE4cRD3Al7lTvHPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cbfaf821-5e26-46d7-8017-57a3c44f44fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "CommonSpirit Penrose Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2222 N Nevada Ave, Colorado Springs, CO 80907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-c9b2-77ab-8609-a52f578b9dfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-c9b2-77ab-8609-a52f578b9dfc",
        "storage_key": "property/6767906449167172/019d021c-c9b2-77ab-8609-a52f578b9dfc.webp",
        "width": 800,
        "height": 551
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/penrose-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=16350633166847560439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-penrose-hospital",
      "poi_latitude": "38.8661872",
      "poi_longitude": "-104.8224825",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 719-776-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e23c-764b-9d50-5ffbb35a6194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e23c-764b-9d50-5ffbb35a6194",
        "storage_key": "property/6767906449167172/019d021c-e23c-764b-9d50-5ffbb35a6194.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAd9SD2BFE4cR90qrYjwe6eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1f1d5bd4-f504-4de8-af56-7ae50a32a73f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "UCHealth Memorial Hospital Central",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 E Boulder St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-a399-73cd-a549-0fc57d95efc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-a399-73cd-a549-0fc57d95efc2",
        "storage_key": "property/6767906449167172/019d021c-a399-73cd-a549-0fc57d95efc2.webp",
        "width": 1250,
        "height": 781
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-memorial-hospital-central/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13025990946729059480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-memorial-hospital-central",
      "poi_latitude": "38.8402345",
      "poi_longitude": "-104.7991331",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 719-365-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e23c-764b-9d50-5ffbb35a6194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e23c-764b-9d50-5ffbb35a6194",
        "storage_key": "property/6767906449167172/019d021c-e23c-764b-9d50-5ffbb35a6194.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcNT_3JFE4cRmGQ9W8CdxbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ff04da31-b9b8-4457-8fe1-8c42c361f740",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Hand & Stone Massage and Facial Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "5262 N Nevada Ave Suite 110, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Relaxing spa offering professional massage therapy and facial services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-a8fd-767d-8f5c-8f2fd1148c72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-a8fd-767d-8f5c-8f2fd1148c72",
        "storage_key": "property/6767906449167172/01a140d7-a8fd-767d-8f5c-8f2fd1148c72.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://handandstone.com/locations/colorado-springs-univ-village/?utm_source=google&utm_medium=organic&utm_campaign=businesslisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=9141206002943184756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hand--stone-massage-and-facial-spa",
      "poi_latitude": "38.9059624",
      "poi_longitude": "-104.8173991",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-999-2276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_2BpbRPE4cRdM8YcG0W3H4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spa"
    },
    {
      "id": "custom_d539bd07-7a02-40ac-87bd-e92a1309eeb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Village Green Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3590 N Carefree Cir, Colorado Springs, CO 80917, USA",
      "poi_short_description": "Multiple baseball & soccer fields, picnic areas & a playground on 19 acres, plus sledding in season.",
      "poi_long_description": "Multiple baseball & soccer fields, picnic areas & a playground on 19 acres, plus sledding in season.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-a847-705e-a057-51c43942620d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-a847-705e-a057-51c43942620d",
        "storage_key": "property/6767906449167172/01a140d7-a847-705e-a057-51c43942620d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.coloradosprings.gov/parks-recreation-and-cultural-services/page/neighborhood-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2221249525527976171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-green-park",
      "poi_latitude": "38.8824026",
      "poi_longitude": "-104.7528439",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-385-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e5fd-7740-967a-3653c1a88998",
        "storage_key": "property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxTuwVJPE4cR65iZvqx20x4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e023f68c-d7ac-45bc-b901-fd8ac376290e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Old Farm Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5316 Old Farm Cir E, Colorado Springs, CO 80917, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-a8b2-765c-8fa5-9acde2acef41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-a8b2-765c-8fa5-9acde2acef41",
        "storage_key": "property/6767906449167172/01a140d7-a8b2-765c-8fa5-9acde2acef41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11348561220562605600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-farm-park",
      "poi_latitude": "38.9024812",
      "poi_longitude": "-104.7290702",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e5fd-7740-967a-3653c1a88998",
        "storage_key": "property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJixXZwxBJE4cRIFZoh00wfp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6e4a10d-ea3f-45a8-9b11-4c85da50a6ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Austin Bluffs Open Space",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1401 Recreation Way, Colorado Springs, CO 80918, USA",
      "poi_short_description": "Woodland area covering 584 acres, featuring distinctive rock formations dating to the Eocene period.",
      "poi_long_description": "Woodland area covering 584 acres, featuring distinctive rock formations dating to the Eocene period.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-ac26-75f1-89b5-dc8e2cc690b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-ac26-75f1-89b5-dc8e2cc690b0",
        "storage_key": "property/6767906449167172/01a140d7-ac26-75f1-89b5-dc8e2cc690b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/austin-bluffs-open-space",
      "poi_directions_map_url": "https://maps.google.com/?cid=12194477614382373400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-bluffs-open-space",
      "poi_latitude": "38.90653",
      "poi_longitude": "-104.7929488",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e5fd-7740-967a-3653c1a88998",
        "storage_key": "property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyx0BD6pPE4cRGNq2-sd8O6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_8b956a75-ae65-4d47-bdc1-9f7174b0c71a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Pulpit Rock Trail Parking Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "6411 N Nevada Ave, Colorado Springs, CO 80918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-ad5b-77fd-8219-e11668d82fde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-ad5b-77fd-8219-e11668d82fde",
        "storage_key": "property/6767906449167172/01a140d7-ad5b-77fd-8219-e11668d82fde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rumble.com/v15kh2f-pulpit-rock-colorado-springs.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11279529465261259419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pulpit-rock-trail-parking-lot",
      "poi_latitude": "38.9186257",
      "poi_longitude": "-104.8139701",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e207-7638-baa9-9336149ab0fa",
        "storage_key": "property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8B2hkVOE4cRm_pygknwiJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_1f1a835f-2fcb-4c00-810a-5f5be0faaca1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Palmer Park Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3650 Maizeland Rd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Mountain-like terrain with trails winding through scrub brush, pines and cacti.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-acfc-722e-a591-91a3bb0bd6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-acfc-722e-a591-91a3bb0bd6e8",
        "storage_key": "property/6767906449167172/01a140d7-acfc-722e-a591-91a3bb0bd6e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11076527494439290367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmer-park-trailhead",
      "poi_latitude": "38.8678562",
      "poi_longitude": "-104.7616803",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e5fd-7740-967a-3653c1a88998",
        "storage_key": "property/6767906449167172/019d021c-e5fd-7740-967a-3653c1a88998.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0WMOfpFE4cR_8Xm-hG7t5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3eca7ed5-4134-48e2-8a16-3fcbeb538b05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Garden of the Gods Visitor & Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "1805 N 30th St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Educational visitor center offering park history exhibits, guided outdoor tours, and on-site dining and shopping.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-980a-75ba-88df-a1562f14c487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-980a-75ba-88df-a1562f14c487",
        "storage_key": "property/6767906449167172/019d021c-980a-75ba-88df-a1562f14c487.webp",
        "width": 1280,
        "height": 334
      },
      "poi_business_url": "https://gardenofgods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6587710856062110015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-of-the-gods-visitor--nature-center",
      "poi_latitude": "38.8783986",
      "poi_longitude": "-104.8697704",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-634-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e1b5-7038-87fe-9463165f5a2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e1b5-7038-87fe-9463165f5a2a",
        "storage_key": "property/6767906449167172/019d021c-e1b5-7038-87fe-9463165f5a2a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6oa22pQE4cRPwmR0h5AbFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_1c17f365-b92e-413d-8a9a-710d792d9dfa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Red Rock Canyon",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3550 W High St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "City preserve with marked walking & biking trails, as well as scenic views of red-rock formations.",
      "poi_long_description": "City preserve with marked walking & biking trails, as well as scenic views of red-rock formations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b3f8-77c8-941b-a7073422bf13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b3f8-77c8-941b-a7073422bf13",
        "storage_key": "property/6767906449167172/01a140d7-b3f8-77c8-941b-a7073422bf13.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://redrockcanyonopenspace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15444699715466012842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-rock-canyon",
      "poi_latitude": "38.8518656",
      "poi_longitude": "-104.8784924",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7e6-7607-aa87-f854e11e39d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7e6-7607-aa87-f854e11e39d4",
        "storage_key": "property/6767906449167172/01a140d7-c7e6-7607-aa87-f854e11e39d4.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4OCqpxaE4cRqqjtyo-YVtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_133a42ef-58d5-4c7f-8c2c-523577ee1ffe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Rock Ledge Ranch Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "3105 Gateway Rd, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Scenic park with old-fashioned houses & interpretive guides depicting farm life from 1775 to 1907.",
      "poi_long_description": "Scenic park with old-fashioned houses & interpretive guides depicting farm life from 1775 to 1907.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b26b-7038-a77c-c16d1bf823aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b26b-7038-a77c-c16d1bf823aa",
        "storage_key": "property/6767906449167172/01a140d7-b26b-7038-a77c-c16d1bf823aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rockledgeranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12594802948814956425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-ledge-ranch-historic-site",
      "poi_latitude": "38.8772719",
      "poi_longitude": "-104.8714347",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-578-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c7ef-7352-991c-128700984b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140d7-c7ef-7352-991c-128700984b45",
        "storage_key": "property/6767906449167172/01a140d7-c7ef-7352-991c-128700984b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXa7n_mxQE4cRiWcoRI26ya4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_f9621ae6-e54d-4eec-be06-52bd49bec60e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Woodmen Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "6910 Mark Dabling Blvd, Colorado Springs, CO 80919, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b19f-712b-af86-1e648b22af8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b19f-712b-af86-1e648b22af8b",
        "storage_key": "property/6767906449167172/01a140d7-b19f-712b-af86-1e648b22af8b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3052945528737043137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodmen-park-and-ride",
      "poi_latitude": "38.9321944",
      "poi_longitude": "-104.8155446",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-385-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e207-7638-baa9-9336149ab0fa",
        "storage_key": "property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8OsQmlOE4cRwRL9fsg9Xio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_76eb2143-5156-4889-a158-0a5fe92d1503",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Black Forest Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7503 Black Forest Rd, Colorado Springs, CO 80908, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-ca23-702e-81bc-4f422a065397.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-ca23-702e-81bc-4f422a065397",
        "storage_key": "property/6767906449167172/019d021c-ca23-702e-81bc-4f422a065397.webp",
        "width": 1262,
        "height": 1280
      },
      "poi_business_url": "https://coloradosprings.gov/mountain-metro/page/park-n-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=1884882744921326491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-forest-park-and-ride",
      "poi_latitude": "38.941474",
      "poi_longitude": "-104.7023467",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e207-7638-baa9-9336149ab0fa",
        "storage_key": "property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVydvbAlJE4cRm4NMtt5yKBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_391bd2e6-0b18-4476-b87e-b37a9e75587b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Colorado Springs Tejon Park-N-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1251 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15928408554245266606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-tejon-park-n-ride",
      "poi_latitude": "38.8154971",
      "poi_longitude": "-104.8235017",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfOKRgBFE4cRrhwVETATDd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_3e4edbd1-82f0-4a09-9ab5-f222aa34e94c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Metro Downtown Bus Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "127 E Kiowa St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b71d-706d-be93-1c9cf09f4d8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b71d-706d-be93-1c9cf09f4d8b",
        "storage_key": "property/6767906449167172/01a140d7-b71d-706d-be93-1c9cf09f4d8b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16550523255779328766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-downtown-bus-terminal",
      "poi_latitude": "38.834925",
      "poi_longitude": "-104.8220235",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDABxhFE4cR_oKRczZFr-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ee5449eb-0f3c-4f16-89a6-78af15136391",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Mountain Metropolitan Transit",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1015 Transit Dr, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b51a-77b8-96a5-4b70886abcfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b51a-77b8-96a5-4b70886abcfa",
        "storage_key": "property/6767906449167172/01a140d7-b51a-77b8-96a5-4b70886abcfa.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "http://mmtransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=722502473995738549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-metropolitan-transit",
      "poi_latitude": "38.8189618",
      "poi_longitude": "-104.8050417",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e614-778f-909c-139d5150a1a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e614-778f-909c-139d5150a1a6",
        "storage_key": "property/6767906449167172/019d021c-e614-778f-909c-139d5150a1a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZnOIvpEE4cRtV3bDyzYBgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_29f73879-6476-4ea1-b0ba-f2e1115a70c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Colorado Springs Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916, USA",
      "poi_short_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_long_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-bf41-709d-b61a-f580c7ddebec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-bf41-709d-b61a-f580c7ddebec",
        "storage_key": "property/6767906449167172/019d021c-bf41-709d-b61a-f580c7ddebec.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.flycos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5054110453719476621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-airport",
      "poi_latitude": "38.8036959",
      "poi_longitude": "-104.7112051",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-550-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e602-77dd-b325-a3ba9b71bb77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e602-77dd-b325-a3ba9b71bb77",
        "storage_key": "property/6767906449167172/019d021c-e602-77dd-b325-a3ba9b71bb77.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQvRTypHE4cRjamJCa7OI0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_58613b53-ad60-40d9-9c51-edf6df77e7a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Woodmoor Dr, Monument, CO 80132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.coloradodot.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11288222978045675874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride",
      "poi_latitude": "39.0945495",
      "poi_longitude": "-104.8621844",
      "poi_miles_from_property": "18.9",
      "poi_walking_minutes": "7 hours 7 mins",
      "poi_biking_minutes": "1 hour 59 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e207-7638-baa9-9336149ab0fa",
        "storage_key": "property/6767906449167172/019d021c-e207-7638-baa9-9336149ab0fa.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeCF5e6tbIcRYonQr_3Sp5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_7f6d474a-ca5d-4b5b-a3f0-f6ed0b6b0ff7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "UCHealth Memorial Hospital North",
      "poi_type": "Health and Wellness",
      "poi_address": "4050 Briargate Pkwy, Colorado Springs, CO 80920, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b836-77a8-b759-dc382f8799fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b836-77a8-b759-dc382f8799fd",
        "storage_key": "property/6767906449167172/01a140d7-b836-77a8-b759-dc382f8799fd.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-memorial-hospital-north/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4884588321556751190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-memorial-hospital-north",
      "poi_latitude": "38.96708",
      "poi_longitude": "-104.7548251",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-364-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e23c-764b-9d50-5ffbb35a6194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e23c-764b-9d50-5ffbb35a6194",
        "storage_key": "property/6767906449167172/019d021c-e23c-764b-9d50-5ffbb35a6194.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6xBhwhME4cRVmNp5DKLyUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7d247eef-510f-4a52-85aa-7fa8f3c3be2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Pikes Peak State College - Rampart Range Campus",
      "poi_type": "Education",
      "poi_address": "2070 Interquest Pkwy, Colorado Springs, CO 80921, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-b920-743e-861a-23cb2bec11bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-b920-743e-861a-23cb2bec11bf",
        "storage_key": "property/6767906449167172/01a140d7-b920-743e-861a-23cb2bec11bf.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "http://www.pikespeak.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5918383181853939208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-state-college---rampart-range-campus",
      "poi_latitude": "38.9926568",
      "poi_longitude": "-104.7889899",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-502-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW1yxfgdNE4cRCNYMnyVSIlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7aa1a6f2-cd32-4578-8cc2-bc8c65c5e866",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Bal Seal Engineering, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Bellprat View, Colorado Springs, CO 80921, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-bb0d-7358-a75f-adfcd8d86610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-bb0d-7358-a75f-adfcd8d86610",
        "storage_key": "property/6767906449167172/01a140d7-bb0d-7358-a75f-adfcd8d86610.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.balseal.com/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=14873096619645000136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bal-seal-engineering-inc",
      "poi_latitude": "38.987998999999995",
      "poi_longitude": "-104.7993642",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 719-884-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzeYhKtNE4cRyNkAFJPaZ84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_44b24b39-331d-4505-a0dd-ed8fa3308b14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Woodmen Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7150 Campus Dr, Colorado Springs, CO 80920, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-bb73-740a-b282-631d99de897e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-bb73-740a-b282-631d99de897e",
        "storage_key": "property/6767906449167172/01a140d7-bb73-740a-b282-631d99de897e.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3726999088647845445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodmen-corporate-center",
      "poi_latitude": "38.934902099999995",
      "poi_longitude": "-104.8113534",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-528-8164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7e5vW29OE4cRRTYPtez1uDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_6b6d27f5-dbcb-4601-b827-c081d3dc8ce6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "United States Air Force Academy",
      "poi_type": "Education",
      "poi_address": "2354 Fairchild Dr Ste 3A15, Air Force Academy, CO 80840, USA",
      "poi_short_description": "Founded in 1954, this famed facility provides training to U.S. Air Force cadets & features exhibits.",
      "poi_long_description": "Founded in 1954, this famed facility provides training to U.S. Air Force cadets & features exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-bc20-76fa-94d9-fb79cb990686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-bc20-76fa-94d9-fb79cb990686",
        "storage_key": "property/6767906449167172/01a140d7-bc20-76fa-94d9-fb79cb990686.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.usafa.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7058847335799811890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-academy",
      "poi_latitude": "38.992837699999995",
      "poi_longitude": "-104.8582914",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 719-333-2025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-dc21-764d-96a6-b1a5699b0003",
        "storage_key": "property/6767906449167172/019d021c-dc21-764d-96a6-b1a5699b0003.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtVAcXNhSE4cRMm8PpkAQ9mE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_00ab4c4c-59d7-4c2c-927e-627fa12a6721",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Peterson SFB Visitor Center west gate",
      "poi_type": "Entertainment",
      "poi_address": "1334 W Stewart Ave, Colorado Springs, CO 80914, USA",
      "poi_short_description": "Military visitor center providing base access and informative resources.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-bf09-727b-851f-ff5d4d0a820c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-bf09-727b-851f-ff5d4d0a820c",
        "storage_key": "property/6767906449167172/01a140d7-bf09-727b-851f-ff5d4d0a820c.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "http://www.peterson.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5291928981150453039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peterson-sfb-visitor-center-west-gate",
      "poi_latitude": "38.8318673",
      "poi_longitude": "-104.7087435",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-556-6660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-d7eb-76b5-937b-2db1dfca15bc",
        "storage_key": "property/6767906449167172/019d021c-d7eb-76b5-937b-2db1dfca15bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIx9R-fxGE4cRL00R2l61cEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_4a2f417c-a4ae-42c0-b2fc-3daf61b575e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Schriever Space Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4186-3708 Enoch Rd, Colorado Springs, CO 80930, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15958673756390935634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schriever-space-force-base",
      "poi_latitude": "38.7977073",
      "poi_longitude": "-104.5131034",
      "poi_miles_from_property": "26.3",
      "poi_walking_minutes": "9 hours 34 mins",
      "poi_biking_minutes": "2 hours 26 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e614-778f-909c-139d5150a1a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e614-778f-909c-139d5150a1a6",
        "storage_key": "property/6767906449167172/019d021c-e614-778f-909c-139d5150a1a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43z-Pv09E4cRUswHkDqZeN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_03c51e3b-acc4-4da3-966a-66049e12cc1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "custom",
      "poi_name": "Fort Carson ACS Center (Army Community Service)",
      "poi_type": "Entertainment",
      "poi_address": "6303 Wetzel Ave Bldg 1526, Fort Carson, CO 80913, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/01a140d7-c068-744a-83bc-8dd7ca552bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140d7-c068-744a-83bc-8dd7ca552bf1",
        "storage_key": "property/6767906449167172/01a140d7-c068-744a-83bc-8dd7ca552bf1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://carson.armymwr.com/ACS",
      "poi_directions_map_url": "https://maps.google.com/?cid=1044166838443651716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-carson-acs-center-army-community-service",
      "poi_latitude": "38.7409199",
      "poi_longitude": "-104.7902457",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 719-526-4590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167172/019d021c-e614-778f-909c-139d5150a1a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-e614-778f-909c-139d5150a1a6",
        "storage_key": "property/6767906449167172/019d021c-e614-778f-909c-139d5150a1a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_2ZKFVCE4cRhDKtEzWgfQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0909c8ce6dac79827d4bd594",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_944fd0b4fff1ad662a77f3fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_30bc0e37505128906c5931ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_3d8362cae82ae5143995fb22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_9afbeed6d9e92d97b2847079",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_651bdce7803a1123cd35c22d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "rating": "5",
      "name": "Paula Chambers",
      "text": "I haven't lived here long, but I already know I'm going to sign a renewal lease at the time needed. Hoping to be a longtime resident. Very quiet,  apt is very well kept up and so are the grounds. I highly recommend this place.  The leasing manager Peggy is awesome, and always willing to answer any questions you may have. I have also spoken with the manager Doug, and he is also very nice.",
      "date": "2025-01-07",
      "title": "false"
    },
    {
      "id": "ec_0926cd69e9f33911149aee1f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "rating": "5",
      "name": "Robbin Boe",
      "text": "My daughter has been living here since February of 2022 and she just signed her renewal to stay at Austin Park for another year. The apartments are missing a few amenities that would be nice (garbage disposal and dishwasher), but they make up for it with reasonable rent, good free parking, and lovely well-maintained grounds. The apartment manager and other staff all care about the property and residents, and the few maintenance requests my daughter has had have been dealt with very promptly. It's a good place to live and I would recommend it.",
      "date": "2023-07-05",
      "title": "false"
    },
    {
      "id": "ec_afed9b74a887e51a257bfce4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "rating": "5",
      "name": "Christina Stein",
      "text": "Quiet, clean, centrally located complex in Colorado Springs.  This place is a gem of a find!  I moved here sight-unseen from out of state last year.  I'm thankful to have landed in such a great place. I can't say enough about our amazing manager Elise and the extraordinary maintenance team of David and John.  I have never rented from such incredible people.   They work hard to make this a wonderful community to live in! Maintenance issues are fixed right away.\n\nA few other nice features: we have A/C, a tree-lined pool, and a great community of neighbors.  I love the trees around the complex--it feels like a taste of nature while being in town.",
      "date": "2021-09-03",
      "title": "false"
    },
    {
      "id": "ec_13e830a31093bd634ca23046",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "rating": "4",
      "name": "Victoria Corona",
      "text": "This is a very nice starter complex for anyone who is looking for a nice decent apartment. It's small, but quiet. I have been living here for almost 6 months now and Kody and Travis do a very good job keeping up on maintenance. Security is on the property throughout the night. The only things I could say that could be improved are the sound installation, they are very thin and you can hear the neighbors talking. The pup pouches tend to run out a lot so there have been times I take my pup out and there's no bags I can use to clean up. Everything else is great and I enjoy living here. I recommend it to anyone that is looking for affordable living in the middle of the city.",
      "date": "2018-08-11",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_dd1751cbc6815db238c17b27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "2520204",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 0,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_2fd3f6769af167732c8bedd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "yardi",
      "external_id": "2520203",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 60,
      "deposit": 300,
      "fee": 0,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d6b0-751a-97c9-7f016172c5d2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Austin Park Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "apartments-with-pool-colorado-springs",
      "search_query": "apartments with pool colorado springs",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Colorado Springs",
      "h2_subtitle": "Dive into luxury living at Austin Park. Discover apartments with pool access in the heart of Colorado Springs and make a splash in style.",
      "page_copy": "Welcome to Austin Park, where luxury meets comfort in the vibrant neighborhood of Village Seven, Colorado Springs. Our community offers residents exclusive access to a refreshing pool, perfectly designed for relaxation and enjoyment. Whether you're swimming laps or lounging poolside, our pool is the ideal place to unwind and cool off after a busy day in Colorado Springs.\n\nAt Austin Park, you don’t just get an apartment; you gain a lifestyle that includes high-speed internet access, bicycle storage, and instant hot water amenities. With the added bonus of a scenic pool view, these apartments with pool in Colorado Springs redefine convenient living. Come experience where community and comfort intertwine.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Colorado Springs",
      "seo_description": "Discover Austin Park apartments with pool access in Colorado Springs. Enjoy luxurious amenities and a vibrant community in Village Seven.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "mountain-view-apartments-el-paso-county",
      "search_query": "mountain view apartments el paso county",
      "category": "Amenity",
      "h1_title": "Mountain View Apartments El Paso County",
      "h2_subtitle": "Discover stunning mountain views at Austin Park. Experience serene living in El Paso County with breathtaking vistas right from your apartment.",
      "page_copy": "Nestled in the picturesque Village Seven neighborhood, Austin Park offers mountain view apartments that provide a tranquil escape in El Paso County. Our spacious residences are designed to bring the beauty of the Colorado landscape directly into your home. Imagine waking up each day to awe-inspiring scenes of the mountains right outside your window.\n\nAustin Park ensures that luxury extends beyond the views with premium amenities such as high-speed internet access, 24-hour facility access, and modern bicycle storage. Plus, with the convenience of instant hot water and the charm of a quaint neighborhood setting, these mountain view apartments in El Paso County offer everything you need for an elevated living experience. Come and see how Austin Park can transform your everyday living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mountain View Apartments in El Paso County",
      "seo_description": "Experience mountain view apartments at Austin Park in El Paso County. Enjoy stunning vistas and luxury living in the heart of Village Seven.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "central-ac-heating-apartments-village-seven",
      "search_query": "central AC heating apartments village seven",
      "category": "Amenity",
      "h1_title": "Central AC Heating Apartments Village Seven",
      "h2_subtitle": "Stay comfortable at Austin Park with central AC and heating. Discover the modern convenience in the heart of Village Seven.",
      "page_copy": "Austin Park, located in the welcoming Village Seven area of Colorado Springs, offers modern apartments equipped with central AC and heating. These features ensure you'll enjoy a perfect temperature year-round, whether it's the warmth of summer or the crisp chill of winter. Come home to comfort in one of our upscale residences.\n\nIn addition to climate-controlled living, residents enjoy a suite of amenities including high-speed internet access and 24-hour access to community facilities. Bicycle storage and a serene pool view add an extra touch of convenience and leisure. Living in our central AC heating apartments in Village Seven also means easy access to nearby shopping, dining, and outdoor activities, making it a prime location for an easygoing lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Central AC Heating Apartments in Village Seven",
      "seo_description": "Experience central AC and heating at Austin Park in Village Seven. Discover comfortable living with premium amenities in Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "playground-family-friendly-apartments-co",
      "search_query": "playground family-friendly apartments CO",
      "category": "Amenity",
      "h1_title": "Playground Family-Friendly Apartments CO",
      "h2_subtitle": "Find the perfect family-friendly home at Austin Park, Colorado Springs. Our apartments boast a safe playground and inviting environment.",
      "page_copy": "Welcome to Austin Park, where family-friendly living is at the forefront in the heart of Colorado Springs. Our apartments cater to families, providing a safe and engaging playground where children can explore, play, and make memories. With ample green spaces, Austin Park ensures both relaxation and fun for the whole family.\n\nOur community in Village Seven features thoughtfully designed residences with modern essentials such as high-speed internet access and instant hot water. Parents will appreciate the 24-hour facility access and bicycle storage, enhancing both convenience and lifestyle. Situated in a vibrant neighborhood and surrounded by numerous family-oriented amenities, Austin Park is the ideal choice for those seeking family-friendly apartments in CO.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground Family-Friendly Apartments in CO",
      "seo_description": "Discover Austin Park's family-friendly apartments in CO, featuring a safe playground. Enjoy community-centric living in Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-colorado-springs",
      "search_query": "energy efficient apartments colorado springs",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments Colorado Springs",
      "h2_subtitle": "Explore sustainable living at Austin Park. Our energy-efficient apartments in Colorado Springs are perfect for eco-conscious residents.",
      "page_copy": "At Austin Park, our energy-efficient apartments in Colorado Springs are designed with sustainability in mind. Enjoy a home that not only reduces your environmental footprint but also contributes to lower utility bills thanks to modern eco-friendly features and practices throughout the community.\n\nLocated in the thriving Village Seven neighborhood, Austin Park combines green living with premium amenities, offering residents high-speed internet access and an energizing pool view. Our commitment to efficiency extends indoors, providing residents with controlled climate comfort using central AC and heating. Embrace the harmony between comfort and sustainability in the heart of Colorado Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments in Colorado Springs",
      "seo_description": "Discover energy-efficient living at Austin Park, Colorado Springs. Eco-friendly amenities and sustainable homes await in our beautiful community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-colorado-springs",
      "search_query": "one bedroom apartments colorado springs",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Colorado Springs",
      "h2_subtitle": "Discover stylish one-bedroom apartments at Austin Park in Colorado Springs. Ideal for those seeking a blend of comfort and convenience.",
      "page_copy": "Welcome to Austin Park in the vibrant Village Seven neighborhood, where our one-bedroom apartments offer the ideal retreat in Colorado Springs. Thoughtfully designed to maximize space and comfort, these units provide a cozy yet modern living experience with features like central AC and heating.\n\nEnjoy a host of amenities including high-speed internet access and a pool view that elevates daily living. Our community also caters to active lifestyles with bicycle storage and 24-hour access to facilities. Austin Park's location in Colorado Springs keeps you connected to dining, shopping, and outdoor adventures, making it the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Colorado Springs",
      "seo_description": "Explore one-bedroom apartments at Austin Park in Colorado Springs. Enjoy modern living with premium amenities in the convenient Village Seven area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167172",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-village-seven",
      "search_query": "two bedroom apartments village seven",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Village Seven",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Village Seven at Austin Park. Perfect for families or roommates seeking comfort and convenience.",
      "page_copy": "Austin Park offers the perfect setting for comfortable living with our spacious two-bedroom apartments in Village Seven, Colorado Springs. These residences provide ample space for families or roommates, featuring modern amenities like high-speed internet access and a stunning pool view, creating a delightful living environment.\n\nNestled in the heart of Village Seven, our community provides convenient access to a variety of local amenities, including shopping centers, dining options, and recreational activities. Residents enjoy the convenience of 24-hour facility access, bicycle storage, and the tranquility of a family-friendly neighborhood. Experience the best of both style and functionality at Austin Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Village Seven",
      "seo_description": "Explore two-bedroom apartments at Austin Park in Village Seven. Spacious layouts with modern amenities in a prime Colorado Springs location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309352317"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263522"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T7WCR7VB"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a5d6cb78-2968-497d-963b-ca802d62a5d7/app.js?property=a5d6cb78-2968-497d-963b-ca802d62a5d7&propertyName=Austin+Park&channelUuid=c248e9c3-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47754542623"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImxkeWZPK2d4Q21ncTF0ZkR6Nysvd1E9PSIsInZhbHVlIjoiM0Zlbk94Mk51cjQzdEl3ZnBmdTV5UT09IiwibWFjIjoiMzhjYjhlNzk1ZTI3NjAyYjkzY2M0OWI5NDZhMzU1NjM3ZWQ2NGIwZDdiZTI5ZGExZWJlYTNlZWRjZmU5ZDk3YiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309352317",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263522",
  "custom_google_gtm_id": "GTM-T7WCR7VB",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a5d6cb78-2968-497d-963b-ca802d62a5d7/app.js?property=a5d6cb78-2968-497d-963b-ca802d62a5d7&propertyName=Austin+Park&channelUuid=c248e9c3-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47754542623",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImxkeWZPK2d4Q21ncTF0ZkR6Nysvd1E9PSIsInZhbHVlIjoiM0Zlbk94Mk51cjQzdEl3ZnBmdTV5UT09IiwibWFjIjoiMzhjYjhlNzk1ZTI3NjAyYjkzY2M0OWI5NDZhMzU1NjM3ZWQ2NGIwZDdiZTI5ZGExZWJlYTNlZWRjZmU5ZDk3YiJ9",
  "custom_audioeye_site_id": "9dbc937b-2d52-4b32-9b82-18a848fd000c",
  "custom_audioeye_site_hash": "6d6cfebe98b777b93986e97e8387bb6b"
};

export const generatedAt = '2026-11-04T23:47:08.932Z';
